<template>
  <div class="house_details">
    <div class="details_top">
      <div class="housing_title">
        <ul class="housing_name_box">
          <li class="housing_approvalStatus" v-if="housingInfo.approvalStatus=='TO_BE_AUDITED'||housingInfo.approvalStatus=='UNABLE'">
            <div v-if="housingInfo.approvalStatus=='TO_BE_AUDITED'">
              <span style="color:#FF8000">该房源正在进行审批中，无法进行编辑、删除、修改状态、带看、实勘等操作，<span style="color:#5E75E6;cursor:pointer;" @click="toApproveManage">查看审批进度></span></span>
            </div>
            <div v-if="housingInfo.approvalStatus=='UNABLE'">
              <span style="color:#FF0000">{{housingInfo.rejectReason}}，<span style="color:#5E75E6;cursor:pointer;" @click="toApproveManage">查看审批进度></span></span><button class="btn" @click="upEditsellShop">重新修改</button>
            </div>
          </li>
          <li class="housing_name">
            {{housingInfo.residentialAreaName}}
            <span>{{housingInfo.housingResourceType}}</span>
            <span class="status">{{housingInfo.statusName}}</span>
            <div class="icon_box">
              <!-- <span v-if="housingInfo.showPermission&&!housingInfo.isTop" @click="topHouse">
                <i class="iconfont icon-icon_zhiding" style="color: #ff3e3e; font-size: 30px;"></i>
              </span>
              <span v-if="housingInfo.showPermission&&housingInfo.isTop" @click="topHouse">
                <i class="iconfont icon-icon_quxiaozhiding" style="color: #ff3e3e; font-size: 30px;"></i>
              </span> -->
              <span v-if="housingInfo.upDown">
                <i class="iconfont icon-icon_shangjia" style="color: #35c483;font-size: 18px;"></i>
              </span>
              <span v-if="housingInfo.showKey">
                <i class="iconfont icon-icon_yuechi" style="color: #ff5ccd;font-size: 18px;"></i>
              </span>
              <span v-if="housingInfo.picture">
                <i class="iconfont icon-icon_tupian" style="color: #ff6666; font-size: 18px;"></i>
              </span>
              <span v-if="housingInfo.showSource">
                <i class="iconfont icon-icon_dujia" style="color: #ffac27; font-size: 18px;"></i>
              </span>
              <span v-if="housingInfo.whetherEntrust">
                <i class="iconfont icon_weituo" style="color: #c99d02; font-size: 18px;"></i>
              </span>
              <div class="integrity-progress-box">
                <span>完整度：</span>
                <el-progress :percentage="housingInfo.integrity" class="integrity-progress"></el-progress>
                <span :style="{color: integrityStyle.color}">{{ integrityStyle.text }}</span>
              </div>
            </div>
          </li>
          <li class="housing_items">
            <span>{{housingInfo.areaName}}/{{housingInfo.tradeAreaName}}</span>
            <span style="margin-left:28px">房源编号：{{housingInfo.houseCodes}}</span>
            <span style="margin-left:28px">房源地址：</span>
            <span v-if="encryption">{{housingInfo.tung}}{{housingInfo.unit}}{{housingInfo.floor}}{{housingInfo.roomNumber}}室</span>
            <span v-else style="width:60px;">*********</span>
            <img v-if="eyeShow&&!housingInfo.whetherRob" src="../../assets/eye.png" style="cursor: pointer;line-height:21px;" @click="isOk" />
          </li>
        </ul>
        <div class="el_dropdown_box">
          <div class="housing_icon">
            <div class="nav-icon" v-if="housingInfo.whetherRob" @click="saveWhetherRob">
              <i class="iconfont icon-icon_qiangpan" style="color:rgb(255,128,0);cursor:pointer;"></i>
              <div class>抢盘</div>
            </div>
            <div class="nav-icon" v-if="housingInfo.showPermission&&!housingInfo.isTop" @click="atTopVisible=true, topDate=''">
              <i class="iconfont icon-icon_zhiding" style="color: #ff3e3e; font-size: 30px;"></i>
              <div class>置顶</div>
            </div>
            <div class="nav-icon" v-if="housingInfo.showPermission&&housingInfo.isTop" @click="topHouse">
              <i class="iconfont icon-icon_quxiaozhiding" style="color: #ff3e3e; font-size: 30px;"></i>
              <div class>取消置顶</div>
            </div>
            <div class="nav-icon" :class="{active:housingInfo.whetherCollection}" @click="setCollect" v-if="housingInfo.approvalStatus==null">
              <i class="iconfont icon-icon_tianjiashoucang"></i>
              <div class>添加收藏</div>
            </div>
            <div class="nav-icon" v-if="permisShow('转出租')">
              <i class="iconfont icon-icon_qiuzu1"></i>
              <div>出租</div>
            </div>
          </div>
          <el-dropdown class="caozuo" trigger="click" placement="bottom-start" @command="handleCommand">
            <el-button type="primary">
              <i class="iconfont icon-xiajiantou"></i>操作
            </el-button>
            <el-dropdown-menu class="housing_dropdown" slot="dropdown">
              <el-dropdown-item command="转盘申请" v-if="permisShow('转盘')" :disabled="overSave" :style="{'color': overSave ? '#999' : ''}">
                <i class="iconfont icon-icon_bieshu add_font"></i>
                <span class="add_sales">转盘</span>
              </el-dropdown-item>
              <el-dropdown-item command="新增跟进" v-if="permisShow('新增跟进')">
                <i class="iconfont icon-icon_genjin add_font"></i>
                <span class="add_sales">新增跟进</span>
              </el-dropdown-item>
<!--              <el-dropdown-item command="房源勘测" v-if="permisShow('实勘编辑')" :disabled="overSave" :style="{'color': overSave ? '#999' : ''}">-->
<!--                <i class="iconfont icon-icon_kancha add_font"></i>-->
<!--                <span class="add_sales">房源实勘</span>-->
<!--              </el-dropdown-item>-->
              <el-dropdown-item command="房源勘测" v-if="permisShow('实勘编辑')">
                <i class="iconfont icon-icon_kancha add_font"></i>
                <span class="add_sales">房源实勘</span>
              </el-dropdown-item>
              <el-dropdown-item command="新增意向" v-if="permisShow('新增意向')" :disabled="overSave" :style="{'color': overSave ? '#999' : ''}">
                <i class="iconfont icon-icon_yixiang add_font"></i>
                <span class="add_sales">新增意向</span>
              </el-dropdown-item>
              <el-dropdown-item command="发起带看" v-if="permisShow('发起带看及反馈')" :disabled="overSave" :style="{'color': overSave ? '#999' : ''}">
                <i class="iconfont icon-icon_daikan add_font"></i>
                <span class="add_sales">发起带看</span>
              </el-dropdown-item>
              <el-dropdown-item command="生成合同" v-if="permisShow('生成合同')&&housingInfo.whetherContract === false" :disabled="overSave" :style="{'color': overSave ? '#999' : ''}">
                <i class="iconfont icon-icon_hetong add_font"></i>
                <span class="add_sales">生成合同</span>
              </el-dropdown-item>
              <el-dropdown-item command="编辑" v-if="permisShow('房源编辑')" :disabled="overSave" :style="{'color': overSave ? '#999' : ''}">
                <i class="iconfont icon-icon_bianji add_font"></i>
                <span class="add_sales">编辑</span>
              </el-dropdown-item>
              <el-dropdown-item command="删除" v-if="permisShow('房源删除')" :disabled="overSave" :style="{'color': overSave ? '#999' : ''}">
                <i class="iconfont icon-icon_shanchu add_font"></i>
                <span class="add_sales">删除</span>
              </el-dropdown-item>
              <el-dropdown-item command="修改状态" v-if="permisShow('房源状态修改')">
                <i class="iconfont icon-icon_xiugai add_font"></i>
                <span class="add_sales">修改状态</span>
              </el-dropdown-item>
              <el-dropdown-item command="纠错" v-if="permisShow('纠错')">
                <i class="iconfont icon-icon_jiucuo add_font"></i>
                <span class="add_sales">纠错</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-dialog title="置顶时间选择" width="500px" :visible.sync="atTopVisible">
          <div class="leaveRequest_content">
            <div class="item">
              <div class="item_div">
                <div>
                  置顶时间<el-input v-model="topDate" placeholder=""></el-input>天
                </div>
              </div>
            </div>
            <div class="item">
              <div style="color:rgb(255, 71, 0)">
                只能输入大于等于1的正整数！到期系统会自动取消置顶
              </div>
            </div>
          </div>
          <div class="dialog-foot">
            <button class="foot-cancel" @click="atTopVisible=false">取消</button>
            <button v-points class="foot-save" @click="topHouse">确定</button>
          </div>
        </el-dialog>
        <el-dialog class="new_bumen" width="800px" title="新增跟进" :visible.sync="dialogTableVisible" :show-close="genjinisShow" :close-on-click-modal="genjinisShow" :close-on-press-escape="genjinisShow">
          <NewFollowAlert from="house" v-if="dialogTableVisible" @removeAddBtn="cancel" @removeFollowAlert="lookOk">
          </NewFollowAlert>
        </el-dialog>
        <el-dialog class="new_key" width="768px" :title="keyTitle" :visible.sync="addKeyVisible">
          <AddKeyAlert v-if="addKeyVisible" @removeKeyAlert="removeKeyAlert" @openImgList="openImgList" :keyId="housingInfo.keyId" :keyShowDetail="keyShow" :addHouseId="housingInfo.buildingInfoId" :houseName="housingInfo.residentialAreaName" :houseTypeone="housingInfo.chambersNumber" :houseTypetwo="housingInfo.officeNumber" :houseArea="housingInfo.areaOfBuilding"></AddKeyAlert>
        </el-dialog>
        <el-dialog class="new_look" width="570px" title="发起带看" :visible.sync="takeLookVisible">
          <TakeLookHouse v-if="takeLookVisible" @removeAddBtn="removeAddBtn"></TakeLookHouse>
        </el-dialog>
        <el-dialog class="turn_attribution" width="400px" :title="personnelData.name" :visible.sync="turnAttriVisible">
          <TurnAttributionAlert v-if="turnAttriVisible" @removeAttributionAlert="removeAttributionAlert" :personnelData="personnelData" :housesIds="housingInfo.buildingInfoId">
          </TurnAttributionAlert>
        </el-dialog>
        <el-dialog class="turn_table" width="318px" title="转盘" :visible.sync="turnTableVisible">
          <TurnTable v-if="turnTableVisible" @removeTable="removeTable" :property="housingInfo.property">
          </TurnTable>
        </el-dialog>
        <el-dialog width="318px" class="housing_online" title="请选择上线渠道" :visible.sync="HousingOnlineVisible">
          <HousingOnline v-if="HousingOnlineVisible" @removeHousing="removeHousing"></HousingOnline>
        </el-dialog>
        <el-dialog class="housing_solid" width="878px" title="新增勘察" :visible.sync="HousingSolidVisible">
          <HousingSolid :append-to-body="true" @removeHousingSolid="removeHousingSolid" :permisList="permisList" :status="curHouseStatus" v-if="HousingSolidVisible"></HousingSolid>
        </el-dialog>
        <el-dialog class="amend_status" title="修改房源状态" :visible.sync="amendStatus" width="320px">
          <div class="amend_status_inner">
            <span>状态：</span>
            <el-select v-model="curHouseStatus" placeholder="请选择" class="select" @visible-change="getstatus">
              <el-option v-for="item in houseStatusList" :key="item.value" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <span slot="footer" class="dialog-status">
            <el-button @click="amendStatus = false">取 消</el-button>
            <el-button v-points type="primary" @click="updateStatus">确 定</el-button>
          </span>
        </el-dialog>


        <el-dialog class="error_status" width="779px" title="新增纠错申请"
                   :visible.sync="errorStatus" >
          <!--                   :show-close="genjinisShow"-->
          <!--                   :close-on-click-modal="genjinisShow"-->
          <!--                   :close-on-press-escape="genjinisShow"-->

          <addErrorHouse v-if="errorStatus"  :append-to-body="true"  @closeAddError="closeAddError"  ></addErrorHouse>
        </el-dialog>
      </div>
    </div>
    <div class="details_tabs" style="margin-top:4px;">
      <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
        <el-tab-pane label="基础信息" name="first">
          <div class="basis_info">
            <div class="owner_information_one">
              <h3>
                <i></i>楼盘信息
              </h3>
              <div class="owner_info_list">
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      面
                      <span class="txthidden">占位</span>积：
                    </span>
                    <span>{{housingInfo.areaOfBuilding}}㎡/{{housingInfo.areaOfUse}}㎡</span>
                  </li>
                  <!-- <li>
                                        <span>
                                            户
                                            <span class="txthidden">占位</span>型：
                                        </span>
                                        <span>{{housingInfo.chambersNumber}}室{{housingInfo.officeNumber}}厅{{housingInfo.toiletNumber}}卫{{housingInfo.balconyNumber}}阳</span>
                                    </li> -->
                  <li>
                    <span>
                      装
                      <span class="txthidden">占位</span>修：
                    </span>
                    <span>{{housingInfo.decorationDegree}}</span>
                  </li>
                  <li>
                    <span>
                      朝
                      <span class="txthidden">占位</span>向：
                    </span>
                    <span>{{housingInfo.orientation}}</span>
                  </li>
                  <li>
                    <span>建筑类型：</span>
                    <span>{{housingInfo.architecturalTypeName}}</span>
                  </li>
                  <li>
                    <span>建筑结构：</span>
                    <span>{{housingInfo.buildingStructure}}</span>
                  </li>
                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      所属楼层：
                    </span>
                    <span>{{housingInfo.belongFloor}}</span>
                  </li>
                  <li>
                    <span>
                      层
                      <span class="txthidden">占位</span>高：
                    </span>
                    <span>{{housingInfo.high}}</span>
                  </li>
                  <li>
                    <span>单层户数：</span>
                    <span>{{housingInfo.singleHousehold}}户</span>
                  </li>
                  <li>
                    <span>
                      总
                      <span class="txthidden">占位</span>层：
                    </span>
                    <span>{{housingInfo.totalFloor}}层</span>
                  </li>
                  <li>
                    <span>
                      年
                      <span class="txthidden">占位</span>代：
                    </span>
                    <span>{{housingInfo.years}}年</span>
                  </li>
                  <!-- <li>
                    <span>房屋结构：</span>
                    <span>{{housingInfo.housingStructure}}</span>
                  </li>-->
                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>完税日期：</span>
                    <span>{{housingInfo.dutyPaidDate}}</span>
                  </li>
                  <li>
                    <span>出证日期：</span>
                    <span>{{housingInfo.giveEvidenceDate}}</span>
                  </li>
                  <li>
                    <span>产证号：</span>
                    <span>{{housingInfo.estateCertificationNo}}</span>
                  </li>
                  <li>
                    <span>是否临街：</span>
                    <span>{{housingInfo.frontage}}</span>
                  </li>
                  <li>
                    <span>
                      产
                      <span class="txthidden">占位</span>权：
                    </span>
                    <span>{{housingInfo.propertyRight}}</span>
                  </li>
                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>产权性质：</span>
                    <span>{{housingInfo.propertyRightNature}}</span>
                  </li>
                  <li>
                    <span>房屋权属：</span>
                    <span>{{housingInfo.housingOwnership}}</span>
                  </li>
                  <li>
                    <span>抵押情况：</span>
                    <span>{{housingInfo.mortgageSituation}}</span>
                  </li>
                  <li>
                    <span>房屋现状：</span>
                    <span>{{housingInfo.houseStatus}}</span>
                  </li>
                  <li>
                    <span>腾房时间：</span>
                    <span>{{housingInfo.vacateTime}}</span>
                  </li>
                </ul>
                <ul class="owner_info_list_one">
                  <li v-if="!keyShow">
                    <span>
                      钥
                      <span class="txthidden">占位</span>匙：
                    </span>
                    <span style="border-bottom:1px solid blue;color:blue;cursor:pointer;" @click="uploadkeylev">{{housingInfo.keyCode?housingInfo.keyCode:"查看钥匙"}}</span>
                  </li>
                  <li v-if="keyShow">
                    <span>
                      钥
                      <span class="txthidden">占位</span>匙：
                    </span>
                    <span style="border-bottom:1px solid blue;color:blue;cursor:pointer;" @click="addkeylev">录入钥匙</span>
                  </li>
                  <li>
                    <span>
                      来
                      <span class="txthidden">占位</span>源：
                    </span>
                    <span>{{housingInfo.source}}</span>
                  </li>
                  <li>
                    <span>房源类型：</span>
                    <span>{{housingInfo.houseLevel}}</span>
                  </li>
                  <li>
                    <span>
                      性
                      <span class="txthidden">占位</span>质：
                    </span>
                    <span>{{housingInfo.property}}</span>
                  </li>
                  <li>
                    <span>是否凶宅：</span>
                    <span>{{housingInfo.unluckyAbodeName}}</span>
                  </li>
                </ul>
              </div>
              <div class="keyStyle">
                <el-dialog title="操作钥匙" :visible.sync="operationVisible" width="600px">
                  <operationKeyAlert v-if="operationVisible" v-on:removeTheBtn="removeTheBtn" v-on:updateKey="updateKey" :buildingInfoId="housingInfo.buildingInfoId" :residentialAreaName="housingInfo.residentialAreaName" :keyId="housingInfo.keyId" :status="housingInfo.keyStatus" :description="housingInfo.description" :storeName="housingInfo.storeName">
                  </operationKeyAlert>
                </el-dialog>
              </div>
            </div>
            <div class="owner_information_two">
              <h3>
                <i></i>业务信息
              </h3>
              <div class="owner_info_list">
                <ul class="owner_info_list_one" style="overflow: hidden">
                  <li>
                    <span>
                      经营行业：
                    </span>
                    <span>{{housingInfo.businessSectorName}}</span>
                  </li>
                  <el-tooltip class="item" effect="dark" :content="housingInfo.applicableToIndustryName" placement="top" v-if="housingInfo.applicableToIndustryName&&housingInfo.applicableToIndustryName.length>18">
                    <li class="basic_info_list_item" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                      <span class="label">适用于行业：</span>
                      <span>{{housingInfo.applicableToIndustryName}}</span>
                    </li>
                  </el-tooltip>
                  <li class="basic_info_list_item" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" v-else>
                    <span class="label">适用于行业：</span>
                    <span v-if="housingInfo.applicableToIndustryName&&housingInfo.applicableToIndustryName.length>0">{{housingInfo.applicableToIndustryName}}</span>
                  </li>
                  <li>
                    <span>
                      经营状态：
                    </span>
                    <span>{{housingInfo.businessStatusName}}</span>
                  </li>

                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      总
                      <span class="txthidden">占位</span>价：
                    </span>
                    <span>{{housingInfo.totalPrice}}万元</span>
                  </li>
                  <li>
                    <span>付款方式：</span>
                    <span>{{housingInfo.paymentMethod}}</span>
                  </li>
                  <li>
                    <span>
                      首
                      <span class="txthidden">占位</span>付：
                    </span>
                    <span>{{housingInfo.installmentAmount}}万元</span>
                  </li>
                  <li>
                    <span>
                      单
                      <span class="txthidden">占位</span>价：
                    </span>
                    <span>{{housingInfo.averagePrice}}元/㎡</span>
                  </li>

                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      底
                      <span class="txthidden">占位</span>价：
                    </span>
                    <span v-if="encryption3">{{housingInfo.floorPrice}}万元</span>
                    <span v-else style="width:60px;">*********</span>
                    <img v-if="eyeShow3&&!housingInfo.whetherRob" src="../../assets/eye.png" style="cursor: pointer;line-height:21px;" @click="isOk3" />
                  </li>
                  <li>
                    <span>交付时间：</span>
                    <span>{{housingInfo.deliveryDate}}</span>
                  </li>
                  <li>
                    <span>税费支付：</span>
                    <span>{{housingInfo.taxPayment}}</span>
                  </li>
                  <li>
                    <span>计税日期：</span>
                    <span>{{housingInfo.taxationDate}}</span>
                  </li>

                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>税<span class="txthidden">占位</span>费：</span>
                    <span v-if="housingInfo.taxation">{{housingInfo.taxation}}元</span>
                  </li>
                  <li>
                    <span>价格条件：</span>
                    <span>{{housingInfo.priceTerms}}</span>
                  </li>
                  <li>
                    <span>看房方式：</span>
                    <span>{{housingInfo.houseInspectionMethod}}</span>
                  </li>
                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>委托日期：</span>
                    <span>{{housingInfo.commissionDate}}</span>
                  </li>
                  <li>
                    <span>到期日期：</span>
                    <span>{{housingInfo.dueDate}}</span>
                  </li>
                  <li>
                    <span>委托方式：</span>
                    <span>{{housingInfo.exclusiveOrNotName}}</span>
                  </li>
                </ul>
              </div>
              <div class="owner_info_twoMore">
                <ul>
                  <li>
                    <span>规<span class="txthidden">占位</span>格：</span>
                    <span>{{housingInfo.specifications}}</span>
                  </li>
                  <li>
                    <span>相关费用：</span>
                    <span>{{housingInfo.relatedExpenses}}</span>
                  </li>
                  <li>
                    <span>客流人群：</span>
                    <span>{{housingInfo.passengerFlowCrowd}}</span>
                  </li>
                </ul>
              </div>
              <div class="owner_info_status">
                <span style="color:#5E75E6;font-size:16px;font-weight:400;text-align:center;">特性</span>
                <ul class="add_fac_item_wrap">
                  <li class="add_fac_item" v-for="(item,index) in housingInfo.featuresDto" :key="index">
                    <i class="iconfont" :class="item.classStyle"></i>
                    <span style="margin-top: 5px; font-size: 12px;">{{item.valueDesc}}</span>
                  </li>
                </ul>
              </div>
              <div class="owner_info_list">
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      备
                      <span class="txthidden">占位</span>注：
                    </span>
                    <span>{{housingInfo.publicRemarks}}</span>
                    <!-- <el-tooltip class="item" :content="housingInfo.publicRemarks" placement="top" effect="light" :disabled="publicRemarks">
                      <span>{{housingInfo.publicRemarks.length>9?housingInfo.publicRemarks.slice(0,9)+"...":housingInfo.publicRemarks}}</span>
                    </el-tooltip>-->
                  </li>
                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>保密备注：</span>
                    <span v-if="encryption4">{{housingInfo.privateRemarks}}</span>
                    <span v-else style="width:60px;">*********</span>
                    <img v-if="eyeShow4&&!housingInfo.whetherRob" src="../../assets/eye.png" style="cursor: pointer;line-height:21px;" @click="isOk4" />
                    <!-- <span>{{housingInfo.privateRemarks}}</span> -->
                    <!-- <el-tooltip class="item" :content="housingInfo.privateRemarks" placement="top" effect="light" :disabled="privateRemarks">
                      <span>{{housingInfo.privateRemarks.length>9?housingInfo.privateRemarks.slice(0,9)+"...":housingInfo.privateRemarks}}</span>
                    </el-tooltip>-->
                  </li>
                </ul>
              </div>
            </div>
            <div class="owner_information_three">
              <h3>
                <i></i>业主信息
              </h3>
              <div class="owner_info_list">
                <ul class="owner_info_list_one">
                  <li>业主</li>
                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      姓
                      <span class="txthidden">占位</span>名：
                    </span>
                    <span v-if="encryption1">{{housingInfo.name}}</span>
                    <span v-else>*********</span>
                    <img v-if="eyeShow1&&!housingInfo.whetherRob" src="../../assets/eye.png" style="cursor: pointer;line-height:21px;" @click="isOk1" />
                  </li>
                  <li>
                    <span>
                      性
                      <span class="txthidden">占位</span>别：
                    </span>
                    <span>{{housingInfo.sex}}</span>
                  </li>
                  <li>
                    <span>
                      婚
                      <span class="txthidden">占位</span>姻：
                    </span>
                    <span>{{housingInfo.marriage}}</span>
                  </li>
                  <li>
                    <span>
                      电
                      <span class="txthidden">占位</span>话：
                    </span>
                    <span v-if="encryption1">
                      <el-tooltip class="item" :content="housingInfo.phone" placement="top" effect="light" v-if="housingInfo.phone.length>11">
                        <span>{{housingInfo.phone}}</span>
                      </el-tooltip>
                      <span v-else>{{housingInfo.phone}}</span>
                    </span>
                    <span v-else>***********</span>
                  </li>
                  <li>
                    <span>证件号：</span>
                    <span v-if="encryption1">{{housingInfo.idNumber}}</span>
                    <span v-else>******************</span>
                  </li>
                  <li>
                    <span>
                      地
                      <span class="txthidden">占位</span>址：
                    </span>
                    <el-tooltip class="item" :content="housingInfo.address" placement="top" effect="light">
                      <span>{{housingInfo.address}}</span>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div class="owner_info_list" v-for="(item,index) in housingInfo.partOwnerInfo" :key="index">
                <ul class="owner_info_list_one">
                  <li>共有人</li>
                </ul>
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      姓
                      <span class="txthidden">占位</span>名：
                    </span>
                    <span v-if="encryption2">{{item.name}}</span>
                    <span v-else>*********</span>
                    <img v-if="eyeShow2&&index==0&&!housingInfo.whetherRob" src="../../assets/eye.png" style="cursor: pointer;line-height:21px;" @click="isOk2" />
                  </li>
                  <li>
                    <span>
                      性
                      <span class="txthidden">占位</span>别：
                    </span>
                    <span>{{item.sexName}}</span>
                  </li>
                  <li>
                    <span>
                      婚
                      <span class="txthidden">占位</span>姻：
                    </span>
                    <span>{{item.marriageName}}</span>
                  </li>
                  <li>
                    <span>
                      电
                      <span class="txthidden">占位</span>话：
                    </span>
                    <span v-if="encryption2">
                      <el-tooltip class="item" :content="item.phone" placement="top" effect="light" v-if="item.phone.length>11">
                        <span>{{item.phone}}</span>
                      </el-tooltip>
                      <span v-else>{{item.phone}}</span>
                    </span>
                    <span v-else>***********</span>
                  </li>
                  <li>
                    <span>证件号：</span>
                    <span v-if="encryption2">{{item.idNumber}}</span>
                    <span v-else>******************</span>
                  </li>
                  <li>
                    <span>
                      地
                      <span class="txthidden">占位</span>址：
                    </span>
                    <el-tooltip class="item" :content="item.address" placement="top" effect="light">
                      <span>{{item.address}}</span>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </div>
            <div class="owner_information_four">
              <h3>
                <i></i>发布信息
              </h3>
              <div class="owner_info_list">
                <ul class="owner_info_list_one">
                  <li>
                    <span>
                      标
                      <span class="txthidden">占位</span>题：
                    </span>
                    <span>{{housingInfo.title}}</span>
                  </li>
                  <li>
                    <span>核心卖点：</span>
                    <span>{{housingInfo.coreSellingPoint}}</span>
                  </li>
                  <li>
                    <span>装修描述：</span>
                    <span>{{housingInfo.decorationDescription}}</span>
                  </li>
                  <li>
                    <span>户型介绍：</span>
                    <span>{{housingInfo.houseTypeDes}}</span>
                  </li>
                  <li>
                    <span>税费解析：</span>
                    <span>{{housingInfo.analysisTaxation}}</span>
                  </li>
                </ul>
              </div>
            </div>

            <!--相关人员-->
            <div class="related-personnel">
              <h3 class="basic_info_title">
                <i></i>相关人员
              </h3>
              <AboutUserTable :data="inputMessage" @click="changePersonnel" :permisShow="permisShow" />
            </div>
            <!--完整度明细-->
            <div class="related-personnel">
              <h3 class="basic_info_title">
                <i></i>完整度明细
              </h3>
              <IntegrityTable :houseInfoId="housingInfo.buildingInfoId" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="跟进信息">
          <div class="ownership_wrap">
            <div class="key_list_wrap">
              <el-table :data="queryFollowUpList" border style="width: 100%" :header-cell-style="tableHeaderColor" highlight-current-row>
                <el-table-column prop="followUpType" label="跟进类型" width="80px;"></el-table-column>
                <el-table-column prop="employeeName" label="跟进人" width="80px;"></el-table-column>
                <el-table-column prop="followUpTime" label="跟进时间"></el-table-column>
                <el-table-column prop="followUpContent" label="跟进内容" width="260px;"></el-table-column>
                <el-table-column prop="whetherRemind" label="跟进提醒" width="80px;"></el-table-column>
                <el-table-column prop="remindStartTime" label="提醒开始时间"></el-table-column>
                <el-table-column prop="remindEndTime" label="提醒结束时间"></el-table-column>
                <el-table-column prop="remindEmployeeIdName" label="提醒对象"></el-table-column>
                <el-table-column prop="remindAdvance" label="提醒提前"></el-table-column>
                <el-table-column prop="remindContent" label="提醒内容"></el-table-column>
              </el-table>
            </div>
            <div class="footer_page">
              <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="意向客户">
          <div class="ownership_wrap">
            <div class="key_list_wrap">
              <el-table :data="queryIntentionList" border style="width: 100%" :header-cell-style="tableHeaderColor" @row-click="rowColorclicks" highlight-current-row>
                <el-table-column prop="customerIntention.cusCode" label="客源编号"></el-table-column>
                <el-table-column prop="customerIntention.customerName" label="客户姓名"></el-table-column>
                <!-- <el-table-column prop="customerIntention.phoneNumber" label="客户电话"></el-table-column> -->
                <el-table-column prop="customerIntention.customerLevel" label="客户级别">
                </el-table-column>
                <el-table-column prop="customerIntention.pubAndPriv" label="性质">
                </el-table-column>
                <el-table-column prop="customerIntention.status" label="状态">
                </el-table-column>
                <el-table-column prop="customerIntention.departmentName" label="部门">
                </el-table-column>
                <el-table-column prop="customerIntention.customerEmployeeName" label="经纪人">
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span v-if="!housingInfo.whetherRob" class="active" style="color: red; border-bottom: 1px solid red;cursor: pointer" :class="{rowColor:scope.row.customerIntention.customerId===isRowColor}" @click="deletes(scope.row)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="footer_page">
              <el-pagination background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="客源匹配" name="匹配">
          <div class="ownership_wrap">
            <div class="key_list_wrap">
              <el-table :data="houseMatchCustomerList" border style="width: 100%" :header-cell-style="tableHeaderColor" @row-click="rowColorclicksp" highlight-current-row>
                <el-table-column prop="cusCode" label="客源编号"></el-table-column>
                <el-table-column prop="customerName" label="客户姓名"></el-table-column>
                <!-- <el-table-column prop="customerIntention.phoneNumber" label="客户电话"></el-table-column> -->
                <el-table-column prop="areaName" label="需求区域">
                </el-table-column>
                <el-table-column prop="residentialAreaName" label="需求小区">
                </el-table-column>
                <el-table-column prop="architecturalType" label="建筑类型">
                </el-table-column>
                <el-table-column prop="area" label="面积(m²)">
                </el-table-column>
                <el-table-column prop="houseType" label="户型">
                </el-table-column>
                <el-table-column prop="totalPrice" label="价格(万元)">
                </el-table-column>
                <el-table-column prop="match" label="匹配度">
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span v-if="scope.row.whetherConversionIntention&&!housingInfo.whetherRob" style="color: #00C473; border-bottom: 1px solid #00C473;cursor: pointer;" :class="{rowColor:scope.row.customerId===isRowColor}" @click="turnIntention(scope.row)">转意向</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="footer_page">
              <el-pagination background @size-change="handleSizeChangep" @current-change="handleCurrentChangep" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="带看信息">
          <div class="ownership_wrap">
            <div class="key_list_wrap">
              <el-table :data="queryWithLookList" border style="width: 100%" :header-cell-style="tableHeaderColor" highlight-current-row @row-click="rowColorclick">
                <el-table-column prop="withLookTime" label="带看日期" width="160"></el-table-column>
                <el-table-column prop="cusCode" label="客源编号" width="120"></el-table-column>
                <el-table-column prop="customerLevel" label="客户等级" width="120"></el-table-column>
                <el-table-column prop="customerName" label="客户姓名" width="120"></el-table-column>
                <el-table-column prop="employeeName" label="带看员工" width="120"></el-table-column>
                <el-table-column prop="withLookEmployeeName" label="陪看员工" width="120"></el-table-column>
                <el-table-column prop="scope" label="带看图片">
                  <template slot-scope="scope">
                    <div @click="showcurlookPicturList(scope.row.id,scope.row.pictures,scope.row.employeeId)">
                      <img style="width:20px; height:20px;margin-top:5px; margin-right: 5px" v-for="item in scope.row.pictures" :key="item.url" :src="'http://'+item.url" alt />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="withLookRemak" label="带看说明"></el-table-column>
                <el-table-column label="带看反馈">
                  <template slot-scope="scope" v-if="!housingInfo.whetherRob">
                    <span v-if="scope.row.facebackRemak">{{scope.row.facebackRemak}}</span>
                    <span v-if="scope.row.facebackRemak==null&&scope.row.oper=='submit'||scope.row.facebackRemak==null&&!btnSave" class="active" :class="{rowColor:scope.row.id===isRowColor}" @click="openFaceback(scope.row.id,scope.row.withLookEmployeeIds,scope.row.employeeName,scope.row.withLookEmployeeName)">添加反馈</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope" v-if="!housingInfo.whetherRob">
                    <span class="active" v-if="scope.row.oper=='submit'||!btnSave" :class="{rowColor:scope.row.id===isRowColor}" @click="showlookPicturList(scope.row.id,scope.row.pictures,scope.row.employeeId)">图片编辑</span>
                    <span style="margin-left:10px;" v-if="scope.row.oper=='TO_BE_AUDITED'&&btnSave" class="active" :class="{rowColor:scope.row.id===isRowColor}" @click="goApproval(scope.row.applyId)">审批中</span>
                    <span style="margin-left:10px;" v-if="scope.row.oper=='submit'&&btnSave" class="active" :class="{rowColor:scope.row.id===isRowColor}" @click="submitApproval(scope.row.id)">提交审批</span>
                    <span style="margin-left:10px;" v-if="scope.row.oper=='cancel'&&btnSave" class="active" :class="{rowColor:scope.row.id===isRowColor}" @click="cancelApproval(scope.row.id)">反审</span>
                    <span v-if="scope.row.whetherConversionIntention&&!housingInfo.whetherRob" style="color: #00C473; border-bottom: 1px solid #00C473;cursor: pointer;margin-left: 10px;" :class="{rowColor:scope.row.id===isRowColor}" @click="turnIntention(scope.row)">转意向</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="footer_page">
              <el-pagination background @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="图片信息" id="la">
          <div class="upload_img">
            <span class="upload_img_title">室内图片</span>
            <el-button v-points class="batchImg" type="primary" v-if="ispc&&permisShow('图片导出')" @click="downLoadImgList">批量导出图片</el-button>
            <el-button v-points class="batchImg" type="primary" style="margin:0 10px;background:rgb(255, 62, 62);border:none" v-if="!imgCheckallShow&&permisShow('图片删除')" @click="imgCheckallShow=true">批量删除图片</el-button>
            <el-button v-points class="batchImg" type="primary" style="margin:0 10px;border:none" v-if='imgCheckallShow' @click="imgCheckallShow=false">取消删除</el-button>
            <el-button v-points class="batchImg" type="primary" style="margin:0 10px;background:rgb(255, 62, 62);border:none" v-if='imgCheckallShow' @click="deletImg(checkAll)">删除图片</el-button>
            <!-- {{checkAll}} -->
            <ul class="upload_img_type">
              <li v-for="(item,index) in buildInfo.indoorPicture" :key="item.url">
                <div class="upload_img_icon" style="position: relative">
                  <img class="img_fengmian" v-if="item.whetherWeb" src="../../assets/images/fengmian.png" alt />
                  <img @click="setCurImg(buildInfo.indoorPicture, buildInfo.surveyIndoorPicture, true, index)" :id="'indoorPicture'+index" :src="'http://'+item.uri" alt />
                  <div style="position: absolute;bottom: 5px;right: 5px;z-index:99">
                    <el-checkbox v-if="imgCheckallShow" :label="item.id" v-model="checkAll"><span style=""></span>
                    </el-checkbox>
                  </div>

                  <!--                  <canvas style="position: absolute;left: 0;right: 0;" :id="'myCanvas'+index" v-if="watermarkData.watermarkStatus">您的浏览器不支持Canvas</canvas>-->
                </div>
                <!-- <el-input v-model="item.label" placeholder="请输入内容"></el-input> -->
                <!-- <span class="txt">{{`${item.employeeName}上传于`}}</span>
                <span class="txt">{{item.uploadTime}}</span>-->
                <span class="txt" v-if="!item.istrue" @click="item.istrue = true">
                  {{item.label}}
                  <i class="iconfont icon-icon_bianji"></i>
                </span>
                <!-- <span class="txt" v-else> <el-input v-model="item.label"></el-input> <i @click="curImg='roomPicture', uploadHouseBtn(item),item.istrue=false" class="el-icon-check"></i></span> -->
                <span class="txt" v-else>
                  <el-autocomplete popper-class="my-autocomplete" v-model="item.label" :fetch-suggestions="getImageLabelList" placeholder="请输入内容" @select="handleSelect">
                    <template slot-scope="{ item }">
                      <div class="valueDesc" @select="handleSelect">{{ item.value }}</div>
                    </template>
                  </el-autocomplete>
                  <i @click="curImg='roomPicture', uploadHouseBtn(item),item.istrue=false" class="el-icon-check"></i>
                </span>
              </li>
              <li v-for="(item,index) in buildInfo.surveyIndoorPicture" :key="item.url">
                <div class="upload_img_icon">
                  <img class="img_shikan" src="../../assets/images/shikan.png" alt />
                  <img class="img_fengmian" v-if="item.whetherWeb" src="../../assets/images/fengmian.png" alt />
                  <img @click="setCurImg(buildInfo.surveyIndoorPicture, buildInfo.indoorPicture, true, index)" :id="'surveyIndoorPicture'+index" :src="'http://'+item.uri" alt />
                  <div style="position: absolute;bottom: 5px;right: 5px;z-index:99">
                    <el-checkbox v-if="imgCheckallShow" :label="item.id" v-model="checkAll"><span style=""></span>
                    </el-checkbox>
                  </div>
                  <!--                  <canvas style="position: absolute;left: 0;right: 0;" :id="'myCanvas1'+index" v-if="watermarkData.watermarkStatus">您的浏览器不支持Canvas</canvas>-->
                </div>
                <span class="txt" v-if="!item.istrue" @click="item.istrue = true">
                  {{item.label}}
                  <i class="iconfont icon-icon_bianji"></i>
                </span>
                <!-- <span class="txt" v-else> <el-input v-model="item.label"></el-input> <i @click="curImg='roomPicture', uploadHouseBtn(item),item.istrue=false"  class="el-icon-check"></i></span> -->
                <span class="txt" v-else>
                  <el-autocomplete popper-class="my-autocomplete" v-model="item.label" :fetch-suggestions="getImageLabelList" placeholder="请输入内容" @select="handleSelect">
                    <template slot-scope="{ item }">
                      <div class="valueDesc" @select="handleSelect">{{ item.value }}</div>
                    </template>
                  </el-autocomplete>
                  <i @click="curImg='roomPicture', uploadHouseBtn(item),item.istrue=false" class="el-icon-check"></i>
                </span>
                <!-- <el-input v-model="item.label" placeholder="请输入内容"></el-input> -->
                <!-- <span class="txt">{{`${item.employeeName}上传于`}}</span>
                <span class="txt">{{item.uploadTime}}</span>-->
              </li>
              <li class="upload_img_icon" @click="showPicturList('roomPicture')">
                <i class="iconfont icon-icon_shinei"></i>
                <span>室内图片</span>
              </li>
              <!-- <li class="upload_img_text">注意：照片请使用真实照片，格式支持jpeg、png等</li> -->
            </ul>
          </div>
          <div class="upload_img">
            <span class="upload_img_title">户型图片</span>
            <ul class="upload_img_type">
              <li v-for="(item,index) in buildInfo.apartmentPicture" :key="item.url">
                <div class="upload_img_icon">
                  <img class="img_fengmian" v-if="item.whetherWeb" src="../../assets/images/fengmian.png" alt />
                  <img @click="setCurImg(buildInfo.apartmentPicture, buildInfo.surveyApartmentPicture, true, index)" :id="'apartmentPicture'+index" :src="'http://'+item.uri" alt />
                  <div style="position: absolute;bottom: 5px;right: 5px;z-index:99">
                    <el-checkbox v-if="imgCheckallShow" :label="item.id" v-model="checkAll"><span style=""></span>
                    </el-checkbox>
                  </div>
                  <!--                  <canvas style="position: absolute;left: 0;right: 0;" :id="'myCanvas2'+index" v-if="watermarkData.watermarkStatus">您的浏览器不支持Canvas</canvas>-->
                </div>
                <!-- <span class="txt">{{`${item.employeeName}上传于`}}</span>
                <span class="txt">{{item.uploadTime}}</span>-->
              </li>
              <li v-for="(item,index) in buildInfo.surveyApartmentPicture" :key="item.url">
                <div class="upload_img_icon">
                  <img class="img_shikan" src="../../assets/images/shikan.png" alt />
                  <img class="img_fengmian" v-if="item.whetherWeb" src="../../assets/images/fengmian.png" alt />
                  <img @click="setCurImg(buildInfo.surveyApartmentPicture, buildInfo.apartmentPicture, true, index)" :id="'surveyApartmentPicture'+index" :src="'http://'+item.uri" alt />
                  <div style="position: absolute;bottom: 5px;right: 5px;z-index:99">
                    <el-checkbox v-if="imgCheckallShow" :label="item.id" v-model="checkAll"><span style=""></span>
                    </el-checkbox>
                  </div>
                  <!--                  <canvas style="position: absolute;left: 0;right: 0;" :id="'myCanvas3'+index" v-if="watermarkData.watermarkStatus">您的浏览器不支持Canvas</canvas>-->
                </div>
                <!-- <span class="txt">{{`${item.employeeName}上传于`}}</span>
                <span class="txt">{{item.uploadTime}}</span>-->
              </li>
              <li class="upload_img_icon" @click="showPicturList('houseTypePicture')">
                <i class="iconfont icon-icon_huxing"></i>
                <span>户型图片</span>
              </li>
              <!-- <li class="upload_img_text">注意：照片请使用真实照片，格式支持jpeg、png等</li> -->
            </ul>
          </div>
          <!--                    <div class="upload_img" v-if="permisShow('保密图片查看')">-->
          <div class="upload_img">
            <span class="upload_img_title">保密图片</span>
            <ul class="upload_img_type">
              <li v-for="(item,index) in buildInfo.secretPicture" :key="item.url">
                <div class="upload_img_icon">
                  <img v-if="permisShow('保密图片查看')" @click="setCurImg(buildInfo.secretPicture, buildInfo.surveySecretPicture, 'noset', index)" :id="'secretPicture'+index" :src="'http://'+item.uri" alt />
                  <img v-else src="../../assets/buildDetail/wuquanchakans.png" alt="">
                  <div style="position: absolute;bottom: 5px;right: 5px;z-index:99">
                    <el-checkbox v-if="imgCheckallShow&&permisShow('保密图片查看')" :label="item.id" v-model="checkAll"><span style=""></span>
                    </el-checkbox>
                  </div>
                  <!--                  <canvas style="position: absolute;left: 0;right: 0;" :id="'myCanvas4'+index" v-if="watermarkData.watermarkStatus">您的浏览器不支持Canvas</canvas>-->
                </div>
                <!-- <span class="txt">{{`${item.employeeName}上传于`}}</span>
                <span class="txt">{{item.uploadTime}}</span>-->
              </li>
              <li v-for="(item,index) in buildInfo.surveySecretPicture" :key="item.url">
                <div class="upload_img_icon">
                  <img v-if="permisShow('保密图片查看')" class="img_shikan" src="../../assets/images/shikan.png" alt />
                  <img v-if="permisShow('保密图片查看')" @click="setCurImg(buildInfo.surveySecretPicture, buildInfo.secretPicture, 'noset', index)" :id="'surveySecretPicture'+index" :src="'http://'+item.uri" alt />
                  <img v-else src="../../assets/buildDetail/wuquanchakans.png" alt="">
                  <div style="position: absolute;bottom: 5px;right: 5px;z-index:99">
                    <el-checkbox v-if="imgCheckallShow&&permisShow('保密图片查看')" :label="item.id" v-model="checkAll"><span style=""></span>
                    </el-checkbox>
                  </div>
                  <!--                  <canvas style="position: absolute;left: 0;right: 0;" :id="'myCanvas5'+index" v-if="watermarkData.watermarkStatus">您的浏览器不支持Canvas</canvas>-->
                </div>
                <!-- <span class="txt">{{`${item.employeeName}上传于`}}</span>
                <span class="txt">{{item.uploadTime}}</span>-->
              </li>
              <li class="upload_img_icon" @click="showPicturList('secretPicture')">
                <i class="iconfont icon_baomi"></i>
                <span>保密图片</span>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="VR">
          <template v-if="buildInfo.surveyVrVideo && buildInfo.surveyVrVideo.length">
            <!--            <span slot="label">
                          <i class="iconfont icon-icon_VR"></i>
                          <span>VR</span>
                        </span>-->
            <ul class="video_ul">
              <li v-for="item in buildInfo.surveyVrVideo">
                <video :src="`http://${item.uri}`" controls></video>
              </li>
            </ul>
          </template>
          <h1 v-else style="height:500px;text-align:center;line-height:500px;">暂无信息</h1>
        </el-tab-pane>
        <el-tab-pane label="视频">
          <template v-if="buildInfo.surveyVideo && buildInfo.surveyVideo.length">
            <!--            <span slot="label">
                          <i class="iconfont icon-icon_youxiandianshi"></i>
                          <span>视频</span>
                        </span>-->
            <ul class="video_ul">
              <li v-for="item in buildInfo.surveyVideo">
                <video :src="`http://${item.uri}`" controls></video>
              </li>
            </ul>
          </template>
          <h1 v-else style="height:500px;text-align:center;line-height:500px;">暂无信息</h1>
        </el-tab-pane>
        <el-tab-pane label="系统日志">
          <div class="key_title">
            <span v-for="(item,index) in tabData" :key="index" v-bind:class="{ activeBtn:index===isActive}" @click="ClassChang(index)">{{item}}</span>
          </div>
          <div class="ownership_wrap" v-if="isShow">
            <div class="key_list_wrap">
              <el-table :data="tableData3" border style="width: 100%" :header-cell-style="tableHeaderColor" highlight-current-row>
                <el-table-column prop="employeeName" label="操作人姓名"></el-table-column>
                <el-table-column prop="operationDate" label="操作时间"></el-table-column>
                <el-table-column prop="houseContent" label="操作内容" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="ownership_wrap" v-if="!isShow">
            <div class="key_list_wrap">
              <el-table :data="tableData3" border style="width: 100%" :header-cell-style="tableHeaderColor" highlight-current-row>
                <el-table-column prop="employeeName" label="操作人姓名"></el-table-column>
                <el-table-column prop="operationDate" label="操作时间"></el-table-column>
                <el-table-column prop="source" label="来源"></el-table-column>
                <el-table-column prop="type" label="类型"></el-table-column>
                <el-table-column label="图片">
                  <template slot-scope="scope">
                    <div @click="imgLogbtn(scope.row.pictures)">
                      <img style="width:20px; height:20px;margin-top:5px; margin-right: 5px" v-for="item in scope.row.pictures" :key="item.url" :src="'http://'+item.url" alt />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="footer_page">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="feedbackDialog">
      <el-dialog class="feedback" title="带看反馈" :visible.sync="feedbackDialog" width="570px">
        <FeedBack @removeFeedback="removeFeedback" :isshow="imgshow" :takeLookName="takeLookName" :watchName="watchName" v-if="feedbackDialog"></FeedBack>
      </el-dialog>
    </div>

    <el-dialog v-if="uploadHouseImgVisible" title="上传房间图片" :visible.sync="uploadHouseImgVisible" @close="closeBtn">
      <UploadImg uploadData="02" v-if="uploadHouseImgVisible" :isshow="true" :isindoorPicture="isIndoorImg" @cancelUpload="uploadHouseImgVisible=false" @saveUpload="uploadHouseBtn"></UploadImg>
    </el-dialog>

    <el-dialog v-if="uploadImgVisible" title="上传图片" :visible.sync="uploadImgVisible" @close="closeBtn">
      <UploadImg uploadData="02" v-if="uploadImgVisible" :propImglist="propimg" :isshow="true" @cancelUpload="uploadImgVisible=false" @saveUpload="upLoadingBtn"></UploadImg>
    </el-dialog>
    <div class="mask" v-if="imgListShow">
      <img class="close" @click="imgListShow=false" src="../../assets/images/close.png" alt />
      <template>
        <el-carousel indicator-position="outside" :initial-index="curImgListIndex" :autoplay='false'>
          <el-carousel-item v-for="(item,index) in curImgList" :key="item.url">
            <img :id="'curimg'+index" :src="'http://'+item.uri" alt />
            <!--            <canvas style="position: absolute;left: 0;right: 0;margin: 0 auto;" :id="'myCanvas6'+index" v-if="watermarkData.watermarkStatus">您的浏览器不支持Canvas</canvas>-->
            <div class="uploadtime">
              <div>

                {{`${item.employeeName}上传于${item.uploadTime}`}}
              </div>
              <div>
                <el-button v-points class="download" v-if="ispc" @click="downLoadImg('http://'+item.uri)" type="primary">下载</el-button>
                <el-button v-points class="delet" @click="deletImg(item.id)" v-if="permisShow('图片删除')" type="danger">删除
                </el-button>
                <el-button v-points v-if="curImgSta!='noset'" class="set" @click="updateWebPicture(item.uri)" type="primary">设为封面
                </el-button>
              </div>

            </div>

          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <!-- 日志图片 -->
    <div class="mask" v-if="imgLogShow">
      <img class="close" @click="imgLogShow=false" src="../../assets/images/close.png" alt />
      <template>
        <el-carousel indicator-position="outside" :autoplay='false'>
          <el-carousel-item v-for="item in curLogList" :key="item">
            <img :src="'http://'+item.url" alt />
            <div class="uploadtime">
              <div></div>
              <el-button class="download" v-if="ispc" @click="downLoadImg('http://'+item.url)" type="primary">下载</el-button>
            </div>

          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <el-dialog v-if="lookImgVisible" title="图片信息" :visible.sync="lookImgVisible" @close="closeBtn">
      <UploadImg uploadData="03" v-if="lookImgVisible" :propImglist="propimg" :isshow="false" @cancelUpload="lookImgVisible=false">
      </UploadImg>
    </el-dialog>
    <!-- 图片放大 -->
    <div class="mask" v-if="imgListShow1">
      <img class="close" @click="imgListShow1=false" src="../../assets/images/close.png" alt />
      <template>
        <el-carousel indicator-position="outside" :autoplay='false'>
          <el-carousel-item v-for="(item,index) in imgList" :key="index">
            <img :src="'http://'+item" />
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
  </div>
</template>
<script type="text/javascript">
import { Loading } from "element-ui";
import { draw } from "../../vue/util/tool";
import { dicGet, queryWhetherFollowUp } from "@/api/index";
import FeedBack from "@/components/common/feedBack";
import NewFollowAlert from "@/components/common/newFollowAlert";
import AddKeyAlert from "@/components/common/addKeyAlert";
import TurnAttributionAlert from "@/components/common/turnAttributionAlert";
import TurnTable from "@/components/common/turnTable";
import HousingOnline from "@/components/common/housingOnline";
import HousingSolid from "@/components/common/housingSolid";
import TakeLookHouse from "@/components/common/takeLookHouse";
import UploadImg from "@/components/common/uploadImg";
import addErrorHouse from "@/components/common/addErrorHouse";

// import { houseTypeDetail } from "@/api/houseManage";
import {
  qiniuMany,
  qiniuOne,
  qiniuToken,
  addWithLookImg,
  uploadDeletImg,
} from "@/api";
import { queryFollowUp, customerLevel } from "@/api/customeManage";
import { queryIntention, queryWithLook, addIntention, deleteIntention } from "@/api/index";
import {
  queryHouseRelatedPersonnel,
  updateHouseStatus,
  houseTypeDetail,
  houseDelete,
  queryHousePictur,
  updateHousePictur,
  updateHouseImg,
  queryLog,
  querypicLog,
  Collect,
  deleteCollect,
  updateWebPicture,
  addHouseLog,
  topHouse,
  queryTopStatus,
  cusOrHouse,
  getResult,
  countLookLimit,
  queryApprovalWhetherOpen,
  updateWithLookStatus,
  checkHousing,
  queryHouseMatchCustomerList
} from "@/api/houseManage";
import operationKeyAlert from "@/components/common/operationKeyAlert";
// import { cusOrHouse, getResult, countLookLimit } from "@/api/houseManage";
import { checkWithLookPicturePermission } from "@/api/manageCenter";
import { getRouterLevel } from '@/vue/util/tool'
import AboutUserTable from "../../components/AboutUser/AboutUserTable";
import IntegrityTable from "../../components/Integrity/IntegrityTable";

export default {
  name: "",
  data() {
    let watermarkData = JSON.parse(sessionStorage.getItem("watermark"));
    return {
      takeLookName: "",
      watchName: "",
      imgList: "",
      imgListShow1: false,//图片放大
      btnSave: false,
      checkAll: [],
      imgCheckallShow: false,
      genjinisShow: true,
      overSave: false,
      isRowColor: "",
      personnelData: "",
      inputMessage: [],
      houseStatusList: [], //房源状态列表
      amendStatus: false, //修改状态弹框状态
      errorStatus:false,//纠错弹窗状态
      watermarkData,
      keyTitle: "新增钥匙",
      eyeShow: true, //眼是否显示
      eyeShow1: true, //眼是否显示
      eyeShow2: true, //眼是否显示
      eyeShow3: true, //眼是否显示
      eyeShow4: true, //眼是否显示
      encryption: false, //是否不加密
      encryption1: false, //是否不加密1
      encryption2: false, //是否不加密2
      encryption3: false, //是否不加密2
      encryption4: false, //是否不加密2
      atTopVisible: false, //置顶弹窗
      topDate: "", //置顶天数
      towardIdList: [], //朝向列表
      permisList: [], //权限列表
      featuresList: [], //特性列表
      houseTypes: "SHOP_SALE", //房源类型
      imgLogShow: false, //日志图片
      curLogList: [], //日志图片数组
      isActive: 0, //当前选中tab
      isShow: true, //切换显示
      tabData: ["房源", "图片"],
      operationVisible: false, //编辑钥匙
      keyShow: false, //录入钥匙
      total: 0,
      currentPage: 1,
      pageNumber: 1,
      pageSize: 10,
      keyicon: "", //钥匙icon
      picture: "", //图片icon
      source: "", //独家icon
      upDown: "", //上架icon
      housingInfo: {
        showPermission: false,
        isTop: false,
        buildingInfoId: "", //房源id
        whetherCollection: null, //收藏
        name: "", //姓名
        analysisTaxation: "", //税费解析
        architecturalType: "",
        areaName: "", //区域
        averagePrice: "", //单价
        buildingStructure: "", //建筑结构
        commissionDate: "", //委托日期
        coreSellingPoint: "", //核心卖点
        decorationDegree: "", //装修程度
        decorationDescription: "", //装修描述
        deliveryDate: "", //交付时间
        dueDate: "", //到期日期
        estateCertificationNo: "", //产证号
        features: "", //特性
        floor: "", //所在楼层
        floorHeight: "", //层高
        floorPrice: "", //底价
        frontage: "", //是否临街
        giveEvidenceDate: "", //出证日期
        houseInspectionMethod: "", //看房方式
        houseLevel: "", //房源类型
        houseStatus: "", //房屋现状
        chamberNumber: "", //室
        officeNumber: "", //厅
        toiletNumber: "", //卫
        balconyNumber: "", //阳
        houseTypeDes: "", //户型介绍
        housingOwnership: "", //房屋权属
        housingResourceType: "", //物业类型
        housingStructure: "", //房屋结构
        idNumber: "", //身份证号
        installmentAmount: "", //分期金额
        keyId: "", //钥匙编号
        level: "", //级别
        marriage: "", //婚姻
        mortgageSituation: "", //抵押
        orientation: "", //朝向
        chambersNumber: "", //室数
        officeNumber: "", //厅数
        toiletNumber: "", //卫数
        balconyNumber: "", //阳台数
        areaOfUse: "", //套内面积 m²
        areaOfBuilding: "", //建筑面积 m²
        ownerName: "", //业主姓名
        partOwnerIdNumber: "", //共有人身份证号
        partOwnerName: "", //共有人姓名
        partOwnerPhone: "", //共有人电话
        partOwnerSex: "", //共有人性别
        paymentMethod: "", //付款方式
        phone: "", //电话
        priceTerms: "", //价格条件
        privateRemarks: "", //保密备注
        property: "", //性质
        propertyRight: "", //产权
        propertyRightNature: "", //产权性质
        publicRemarks: "", //备注
        residentialAreaName: "", //小区
        roomNumber: "", //房号
        sex: "", //性别
        singleHousehold: "", //单层户数
        source: "", //来源
        status: "", //状态
        taxPayment: "", //税费支付
        title: "", //标题
        totalFloor: "", //总层
        totalPrice: "", //总价
        tradeArea: "", //商圈
        tung: "", //栋座
        unit: "", //单元
        vacateTime: "", //腾房时间
        verificationNo: "", //核验编号
        years: "", //年代
      },
      buildInfo: {
        apartmentPicture: [],
        indoorPicture: [],
        secretPicture: [],
      },
      queryFollowUpList: [],
      queryWithLookList: [],
      queryIntentionList: [],
      doorModelImage: [],
      activeName2: "first",
      dialogTableVisible: false,
      addKeyVisible: false,
      turnAttriVisible: false,
      turnTableVisible: false,
      HousingOnlineVisible: false,
      HousingSolidVisible: false,
      takeLookVisible: false,
      feedbackDialog: false,
      tableData3: [], //日志
      curImg: "", //当前图片类型
      uploadImgVisible: false, //带看图片上传现实隐藏
      uploadHouseImgVisible: false, //房间图片上传
      lookImgVisible: false, //查看图片信息列表
      propimg: [],
      imgshow: true, //弹窗图片是否有添加功能
      curHouseStatus: "", //当前的房屋状态
      curImgList: [], //当前图片列表
      curImgListIndex: 0, //当前图片索引
      curImgSta: true, //当前图片列表是否可以设置默认图
      imgListShow: false, //图片列表弹窗
      isIndoorImg: false, //是否为室内图片弹窗
      ImageLabelList: [], //图片描述列表
      houseMatchCustomerList: [],//客源匹配列表
    };
  },

  inject: ["ispc"],

  mounted() {
    sessionStorage.removeItem("cusOrHouse");
    sessionStorage.removeItem("lookType");
    this.keyicon = sessionStorage.getItem("keyicon");
    this.picture = sessionStorage.getItem("picture");
    this.source = sessionStorage.getItem("source");
    this.upDown = sessionStorage.getItem("upDown");
    this.getDetailsBtn();
    this.getImgFolder();
    this.queryHousePictur(); //房源图片信息

    this.getApproval();//查询是否待审批
  },

  watch: {
    topDate: function () {
      let regNumber = /^\+?[1-9][0-9]*$/;
      if (!regNumber.test(this.topDate)) {
        this.topDate = "";
      }
    },
  },

  computed: {
    integrityStyle() {
      const num = this.housingInfo.integrity || 0
      let color = '';
      let text = ''
      if (num >= 70) {
        color = '#3BC588'
        text = '优'
      } else if (num >= 50) {
        color = '#9EC947'
        text = '良'
      } else if (num >= 20) {
        color = '#FDCC01'
        text = '中'
      } else {
        color = 'red'
        text = '差'
      }
      return { text, color }
    }
  },
  created() {
    this.getstatus(true);
  },
  methods: {
    //取消纠错
    closeAddError(){
      this.errorStatus = false;
    },
    //查询匹配客源列表
    queryHouseMatchCustomerList() {
      let params = {
        houseId: this.housingInfo.buildingInfoId,
        "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
      };
      this.$post(queryHouseMatchCustomerList, params).then(res => {
        this.houseMatchCustomerList = res.data;
        this.total = res.total;
      })
    },
    //删除意向客源
    deletes(val) {
      this.$confirm("删除后将不可恢复！", "您确认要删除该意向客源吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        distinguishCancelAndClose: false
      }).then(() => {
        let params = {
          houseId: this.housingInfo.buildingInfoId,
          customerId: val.customerIntention.customerId,
        };
        this.$post(deleteIntention, params).then(res => {
          if (res.success) {
            this.$message.success(res.msg);
            this.getQueryIntention();
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(action => {
      });

    },
    //转意向
    turnIntention(val) {
      this.$confirm("", "您确定要把该客户转成意向客户吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        distinguishCancelAndClose: false
      }).then(() => {
        //添加意向
        let params = {
          customerId: val.customerId ? val.customerId : val.customerIntention.customerId,
          houseIds: val.houseId ? val.houseId : this.housingInfo.buildingInfoId
        };
        this.$post(addIntention, params).then(res => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.isRowColor = '';
            this.getQueryWithLookList();
            this.queryHouseMatchCustomerList();
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }).catch(action => {
      });

    },
    //反审
    cancelApproval(id) {
      let params = {
        id: id,
        status: "WAITING_FOR_SUBMIT",
      }
      this.$post(updateWithLookStatus, params).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.isRowColor = '';
          this.getQueryWithLookList();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      })
    },
    //提交审批
    submitApproval(id) {
      let params = {
        id: id,
        buildingInfoId: sessionStorage.getItem("sellShopbuildId"),
        status: "WAITING_FOR_APPROVAL",
      }
      this.$post(updateWithLookStatus, params).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.isRowColor = '';
          this.getQueryWithLookList();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      })
    },
    //跳转审批详情
    goApproval(id) {
      sessionStorage.setItem('customerApplyId', id);
      this.$router.push({ path: "/approveManage" });
    },
    //查询是否开启待审批
    getApproval() {
      let params = {
        approvalType: "whether_house_look"
      }
      this.$post(queryApprovalWhetherOpen, params).then(res => {
        if (res.success) {
          if (res.data) {
            this.btnSave = true;
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      })
    },
    upEditsellShop() {
      let params = {
        roomId: this.housingInfo.dicRoomId,
        housingProperty: "SECONDHAND"
      };
      this.$post(checkHousing, params).then(res => {
        if (res.success) {
          sessionStorage.setItem("editsellShopbuildId", this.housingInfo.buildingInfoId);
          this.$router.push({ path: "/editSellShop" });
        } else {
          this.$message({
            type: "error",
            message: "该房源已存在"
          });
        }
      });

    },
    //跳转审批
    toApproveManage() {
      this.$router.push({ path: "/approveManage" });
      sessionStorage.setItem('customerApplyId', this.housingInfo.approvalId)
    },
    //是否上次未跟进
    queryWhetherFollowUp() {
      let params = {
        type: 0,
        houseId: this.housingInfo.buildingInfoId,
      };
      this.$post(queryWhetherFollowUp, params).then((res) => {
        // console.log(res)
        if (res.data.houseType == "address") {
          sessionStorage.setItem("lookType", "address");
          sessionStorage.setItem("followFrom", "HOUSE_ADDRESS");
          sessionStorage.setItem("encryption", "房源地址");
          this.dialogTableVisible = true;
          this.genjinisShow = false;
        } else if (res.data.houseType == "yezhuName") {
          sessionStorage.setItem("lookType", "yezhuName");
          sessionStorage.setItem("followFrom", "PHONE");
          sessionStorage.setItem("encryption", "业主姓名");
          this.dialogTableVisible = true;
          this.genjinisShow = false;
        } else if (res.data.houseType == "gongyourenName") {
          sessionStorage.setItem("lookType", "gongyourenName");
          sessionStorage.setItem("followFrom", "PHONE");
          sessionStorage.setItem("encryption", "共有人");
          this.dialogTableVisible = true;
          this.genjinisShow = false;
        } else if (res.data.houseType == "floorPrice") {
          sessionStorage.setItem("lookType", "floorPrice");
          sessionStorage.setItem("followFrom", "LOW_PRICE");
          sessionStorage.setItem("encryption", "底价");
          this.dialogTableVisible = true;
          this.genjinisShow = false;
        } else if (res.data.houseType == "ConfidentialRemarks") {
          sessionStorage.setItem("lookType", "ConfidentialRemarks");
          sessionStorage.setItem("followFrom", "SECRECY_MESSAGE");
          sessionStorage.setItem("encryption", "保密备注");
          this.dialogTableVisible = true;
          this.genjinisShow = false;
        }
      });
    },
    //编辑钥匙
    uploadkeylev() {
      let result = this.permisList.indexOf("查看钥匙");
      if (result >= 0) {
        this.addKeyVisible = true;
      } else {
        this.$message.error("暂无查看钥匙权限");
      }
    },
    //新增钥匙
    addkeylev() {
      let result = this.permisList.indexOf("钥匙新增");
      if (result >= 0) {
        this.addKeyVisible = true;
      } else {
        this.$message.error("暂无钥匙新增权限");
      }
    },
    // 抢盘
    // saveWhetherRob() {
    //   let params = {
    //     detailId: this.housingInfo.id,
    //     type: "HOUSE"
    //   }
    //   this.$post(cusOrHouse, params).then(res => {
    //     if (res.success) {
    //       this.$post(getResult, params).then(ress => {
    //         if (ress.success) {
    //           this.$message.success(res.msg);
    //         } else {
    //           this.$message.error(res.msg);
    //         }
    //       })

    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   })

    // },
    //抢盘
    saveWhetherRob() {
      if (this.housingInfo.message) {
        this.$message.warning(this.housingInfo.message);
      } else {
        let params = {
          detailId: this.housingInfo.buildingInfoId,
          type: "HOUSE",
        };
        this.$post(cusOrHouse, params).then((res) => {
          if (res.success) {
            this.getOK();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    //判断是否秒杀成功
    getOK() {
      let params = {
        detailId: this.housingInfo.buildingInfoId,
        type: "HOUSE",
      };
      // let loading = null;
      this.$post(getResult, params).then((ress) => {
        if (ress.success) {
          // console.log("秒杀数据", ress.data);
          if (ress.data.status == 0) {
            // loading = this.$loading({
            //   lock: true,
            //   text: '拼命加载中',
            //   spinner: 'el-icon-loading',
            //   background: 'rgba(0, 0, 0, 0.7)'
            // });
            Loading.service({
              background: "rgba(0, 0, 0, 0.7)",
              lock: true,
              text: "拼命加载中",
              spinner: "el-icon-loading",
            });
            setTimeout(() => {
              this.getOK();
            }, 3000);
          } else {
            Loading.service().close();
            this.getDetailsBtn();
            // console.log("判段石佛", ress.data.whether)
            if (ress.data.whether) {
              this.$message.success("抢盘成功！");
            } else {
              this.$message.error("已被人抢走！");
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //修改当前行字体颜色
    rowColorclick(row) {
      this.isRowColor = row.id;
    },
    rowColorclicks(row) {
      this.isRowColor = row.customerIntention.customerId;
    },
    rowColorclicksp(row) {
      console.log(row)
      this.isRowColor = row.customerId;
    },
    //修改相关人员
    changePersonnel(item) {
      this.personnelData = item;
      this.turnAttriVisible = true;
    },
    //查询房源相关人员
    getHouseRelatedPersonnel() {
      let params = {
        buildingInfoId: this.housingInfo.buildingInfoId,
      };
      this.$post(queryHouseRelatedPersonnel, params).then((res) => {
        if (res.success) {
          this.inputMessage = res.data;
          // this.inputMessage = res.data.list;
          // if (this.inputMessage) {
          //   this.inputMessage[0].name = "录入人";
          //   this.inputMessage[1].name = "维护人";
          //   this.inputMessage[2].name = "实勘人";
          //   this.inputMessage[3].name = "钥匙人";
          //   this.inputMessage[4].name = "图片人";
          // }
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //修改房源状态
    updateStatus() {
      if (!this.curHouseStatus) {
        this.$message({
          type: "error",
          message: "请选择状态",
        });
        return;
      }
      let params = {
        buildingInfoId: this.housingInfo.buildingInfoId,
        status: this.curHouseStatus,
        oldStatus: this.housingInfo.statusName,
        oldEnglishStatus: this.housingInfo.status,
        residentialAreaId: this.housingInfo.residentialAreaId,
      };
      this.$post(updateHouseStatus, params).then((res) => {
        if (res.success === true) {
          this.amendStatus = false;
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getDetailsBtn();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //查询房源状态
    getstatus(value) {
      if (value) {
        let params = {
          code: "secondBusinessStatus",
        };
        this.$post(dicGet, params).then((res) => {
          if (res.success) {
            this.houseStatusList = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      }
    },
    //是否有查看权限
    isOk() {
      let params = {
        roleId: sessionStorage.getItem("roleId"),
        employeeId: this.housingInfo.employeeId,
        type: 2,
      };
      this.$post(countLookLimit, params).then((res) => {
        if (res.success) {
          if (this.permisList) {
            let result = this.permisList.indexOf(
              "查看房源地址是否需要录入跟进"
            );
            //录入查看日志
            let params = {
              houseId: this.housingInfo.buildingInfoId,
              content:
                "查看了房源编号为" +
                this.housingInfo.houseCodes +
                "的房源地址",
            };
            this.$post(addHouseLog, params).then((res) => {
              if (res.success) {
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
            if (result < 0) {
              this.encryption = true;
              this.eyeShow = false;
            } else {
              let params = {
                type: 1,
                houseId: this.housingInfo.buildingInfoId,
                houseType: "address",
              };
              this.$post(queryWhetherFollowUp, params).then(
                (res) => {
                  // console.log(res);
                }
              );
              this.genjinisShow = false;
              sessionStorage.setItem("encryption", "房源地址");
              this.dialogTableVisible = true;
              this.encryption = false;
              sessionStorage.setItem("cusOrHouse", "HOUSE");
              sessionStorage.setItem("lookType", "address");
              sessionStorage.setItem(
                "followFrom",
                "HOUSE_ADDRESS"
              );
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //是否有查看权限
    isOk1() {
      let params = {
        roleId: sessionStorage.getItem("roleId"),
        employeeId: this.housingInfo.employeeId,
        type: 1,
      };
      this.$post(countLookLimit, params).then((res) => {
        if (res.success) {
          if (this.permisList) {
            let result = this.permisList.indexOf(
              "查看业主电话等是否需要录入跟进"
            );
            //录入查看日志
            let params = {
              houseId: this.housingInfo.buildingInfoId,
              content:
                "查看了房源编号为" +
                this.housingInfo.houseCodes +
                "的业主信息",
            };
            this.$post(addHouseLog, params).then((res) => {
              if (res.success) {
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
            if (result < 0) {
              this.encryption1 = true;
              this.eyeShow1 = false;
            } else {
              let params = {
                type: 1,
                houseId: this.housingInfo.buildingInfoId,
                houseType: "yezhuName",
              };
              this.$post(queryWhetherFollowUp, params).then(
                (res) => {
                  // console.log(res);
                }
              );
              this.genjinisShow = false;
              sessionStorage.setItem("encryption", "业主姓名");
              this.dialogTableVisible = true;
              this.encryption1 = false;
              sessionStorage.setItem("cusOrHouse", "HOUSE");
              sessionStorage.setItem("lookType", "yezhuName");
              sessionStorage.setItem("followFrom", "PHONE");
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //是否有查看权限
    isOk2() {
      let params = {
        roleId: sessionStorage.getItem("roleId"),
        employeeId: this.housingInfo.employeeId,
        type: 1,
      };
      this.$post(countLookLimit, params).then((res) => {
        if (res.success) {
          if (this.permisList) {
            let result = this.permisList.indexOf(
              "查看业主电话等是否需要录入跟进"
            );
            //录入查看日志
            let params = {
              houseId: this.housingInfo.buildingInfoId,
              content:
                "查看了房源编号为" +
                this.housingInfo.houseCodes +
                "的共有人信息",
            };
            this.$post(addHouseLog, params).then((res) => {
              if (res.success) {
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
            if (result < 0) {
              this.encryption2 = true;
              this.eyeShow2 = false;
            } else {
              let params = {
                type: 1,
                houseId: this.housingInfo.buildingInfoId,
                houseType: "gongyourenName",
              };
              this.$post(queryWhetherFollowUp, params).then(
                (res) => {
                  // console.log(res);
                }
              );
              this.genjinisShow = false;
              sessionStorage.setItem("encryption", "共有人");
              this.dialogTableVisible = true;
              this.encryption2 = false;
              sessionStorage.setItem("cusOrHouse", "JOINHOUSE");
              sessionStorage.setItem(
                "lookType",
                "gongyourenName"
              );
              sessionStorage.setItem("followFrom", "PHONE");
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //是否有查看权限
    isOk3() {
      if (this.permisList) {
        let result = this.permisList.indexOf(
          "查看底价是否需要录入跟进"
        );
        //录入查看日志
        let params = {
          houseId: this.housingInfo.buildingInfoId,
          content:
            "查看了房源编号为" +
            this.housingInfo.houseCodes +
            "的底价信息",
        };
        this.$post(addHouseLog, params).then((res) => {
          if (res.success) {
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
        if (result < 0) {
          this.encryption3 = true;
          this.eyeShow3 = false;
        } else {
          let params = {
            type: 1,
            houseId: this.housingInfo.buildingInfoId,
            houseType: "floorPrice",
          };
          this.$post(queryWhetherFollowUp, params).then((res) => {
            // console.log(res);
          });
          this.genjinisShow = false;
          sessionStorage.setItem("encryption", "底价");
          this.dialogTableVisible = true;
          this.encryption3 = false;
          sessionStorage.setItem("cusOrHouse", "HOUSE");
          sessionStorage.setItem("lookType", "floorPrice");
          sessionStorage.setItem("followFrom", "LOW_PRICE");
        }
      }
    },
    //是否有查看权限
    isOk4() {
      if (this.permisList) {
        let result = this.permisList.indexOf(
          "查看保密信息是否需要录入跟进"
        );
        //录入查看日志
        let params = {
          houseId: this.housingInfo.buildingInfoId,
          content:
            "查看了房源编号为" +
            this.housingInfo.houseCodes +
            "的保密备注信息",
        };
        this.$post(addHouseLog, params).then((res) => {
          if (res.success) {
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
        if (result < 0) {
          this.encryption4 = true;
          this.eyeShow4 = false;
        } else {
          let params = {
            type: 1,
            houseId: this.housingInfo.buildingInfoId,
            houseType: "ConfidentialRemarks",
          };
          this.$post(queryWhetherFollowUp, params).then((res) => {
            // console.log(res);
          });
          this.genjinisShow = false;
          sessionStorage.setItem("encryption", "保密备注");
          this.dialogTableVisible = true;
          this.encryption4 = false;
          sessionStorage.setItem("cusOrHouse", "HOUSE");
          sessionStorage.setItem("lookType", "ConfidentialRemarks");
          sessionStorage.setItem("followFrom", "SECRECY_MESSAGE");
        }
      }
    },
    getbuildlist() {
      // 查询朝向
      let params = { code: "orientation" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          this.towardIdList = res.data;
          this.towardIdList.map((item, index) => {
            if (this.housingInfo.orientation == item.value) {
              this.housingInfo.orientation = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    permisShow(data) {
      // 权限配置

      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        //cosole.log("权限列表", data, result);
        return true;
      } else {
        return false;
      }
    },
    //收藏
    setCollect() {
      if (!this.housingInfo.whetherCollection) {
        //添加收藏
        let params = {
          houseIds: this.housingInfo.buildingInfoId,
          transactionType: this.houseTypes,
        };
        this.$post(Collect, params).then((res) => {
          if (res.success) {
            this.$message({
              message: "收藏成功",
              type: "success",
            });
            this.getDetailsBtn();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      } else {
        //取消收藏
        let params = {
          houseId: this.housingInfo.buildingInfoId,
        };
        this.$post(deleteCollect, params).then((res) => {
          if (res.success) {
            this.$message({
              message: "取消收藏",
              type: "success",
            });
            this.getDetailsBtn();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      }
    },
    //日志图片
    imgLogbtn(imgList) {
      this.curLogList = imgList;
      //cosole.log(this.curLogList);
      this.imgLogShow = true;
    },
    //动态绑定class
    ClassChang(index) {
      this.isActive = index;
      this.currentPage = 1;
      this.pageNumber = 1;
      this.pageSize = 10;
      // console.log("切花", this.currentPage);
      if (this.isActive === 0) {
        this.isShow = true;
        this.querWorkbook();
      } else if (this.isActive === 1) {
        this.isShow = false;
        this.querypicLog();
      }
    },
    // 获取图片描述列表
    getImageLabelList(queryString, cb) {
      let params = {
        valueDesc: queryString,
        code: "pictureLabel",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          this.ImageLabelList = res.data;
          let result = this.ImageLabelList;
          cb(result);
        } else {
        }
      });
    },
    // 图片描述回调
    handleSelect(item) {
      //cosole.log(111, item);
    },

    // 设置当前图片列表
    setCurImg(data, data1, sta, index) {
      let newarr = [...data, ...data1];
      this.curImgList = Object.assign([], newarr);

      this.curImgListIndex = index;
      this.curImgSta = sta;
      // this.curImgList.map((item, index) => {
      //   draw(
      //     "curimg" + index,
      //     this.watermarkData.watermarkType,
      //     "http://" + item.uri,
      //     "http://" + this.watermarkData.pictureAddress,
      //     "myCanvas6" + index,
      //     this.watermarkData.transparency,
      //     this.watermarkData.watermarkLocation,
      //     this.watermarkData.horizontalDistance,
      //     this.watermarkData.verticalMargin
      //   );
      // });
      this.imgListShow = true;
    },
    //取消编辑钥匙
    removeTheBtn() {
      this.operationVisible = false;
      this.getDetailsBtn();
    },
    //更新钥匙
    updateKey() {
      this.operationVisible = false;
      this.getDetailsBtn();
    },
    removeFeedback() {
      this.feedbackDialog = false;
      this.getQueryWithLookList();
      this.isRowColor = "";
    },
    removeKeyAlert() {
      this.addKeyVisible = false;
      this.getDetailsBtn();
    },
    //图片放大
    openImgList(val) {
      this.imgListShow1 = true;
      this.imgList = val;
    },
    removeAttributionAlert() {
      this.getDetailsBtn();
      this.turnAttriVisible = false;
    },
    //新增跟进
    lookOk() {
      let encryptionShow = sessionStorage.getItem("encryption");
      if (encryptionShow == "房源地址") {
        this.encryption = true;
        this.eyeShow = false;
      } else if (encryptionShow == "业主姓名") {
        this.encryption1 = true;
        this.eyeShow1 = false;
      } else if (encryptionShow == "共有人") {
        this.encryption2 = true;
        this.eyeShow2 = false;
      } else if (encryptionShow == "底价") {
        this.encryption3 = true;
        this.eyeShow3 = false;
      } else if (encryptionShow == "保密备注") {
        this.encryption4 = true;
        this.eyeShow4 = false;
      }
      sessionStorage.removeItem("encryption");

      this.dialogTableVisible = false;
      this.getQueryFollowUpList();
    },
    //取消新增跟进
    cancel() {
      sessionStorage.removeItem("encryption");
      this.dialogTableVisible = false;
    },
    removeTable() {
      this.getDetailsBtn();
      this.turnTableVisible = false;
    },
    removeHousing() {
      this.HousingOnlineVisible = false;
    },
    removeHousingSolid() {
      this.queryHousePictur();
      this.HousingSolidVisible = false;
    },
    removeAddBtn() {
      this.takeLookVisible = false;
      this.getQueryWithLookList();
    },
    handleClick(tab, event) {
      this.isRowColor = "";
      this.currentPage = 1;
      this.pageNumber = 1;
      this.pageSize = 10;
      if (tab.label == "跟进信息") {
        this.getQueryFollowUpList(); //查询跟进
      } else if (tab.label == "意向客户") {
        this.getQueryIntention(); //客源匹配
      } else if (tab.label == "客源匹配") {
        this.queryHouseMatchCustomerList(); //客源匹配
      } else if (tab.label == "带看信息") {
        this.getQueryWithLookList(); //带看信息
      } else if (tab.label == "系统日志") {
        this.isActive = 0;
        this.isShow = true;
        this.querWorkbook(); //查询房源日志
      }
    },
    tableHeaderColor({ row, rowIndex }) {
      return "background-color: #F2F4FF";
    },
    handleCommand(command) {
      if (command === "新增跟进") {
        this.dialogTableVisible = true;
        this.genjinisShow = true;
        sessionStorage.setItem("followFrom", "house");
        sessionStorage.removeItem("cusOrHouse");
      } else if (command === "编辑") {
        sessionStorage.setItem("editsellShopbuildId", this.housingInfo.buildingInfoId);
        this.$router.push({ path: "/editSellShop" });
      } else if (command === "房源勘测") {
        this.HousingSolidVisible = true;
      } else if (command === "新增意向") {
        this.$router.push({ path: "/newIntentionHouse" });
      } else if (command === "添加钥匙") {
        this.addKeyVisible = true;
      } else if (command === "发起带看") {
        this.takeLookVisible = true;
      } else if (command === "转盘申请") {
        this.turnTableVisible = true;
      } else if (command === "房源上线") {
        this.HousingOnlineVisible = true;
      } else if (command === "删除") {
        this.$confirm(
          "删除后将不可恢复！",
          "您确认要删除该条房源吗？",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            center: true,
            distinguishCancelAndClose: true,
          }
        ).then(() => {
          this.delete();
        });
      } else if (command === "生成合同") {
        this.$store.commit("delete_tabs", "/contractEntering");
        this.$store.commit("delete_clude", "/contractEntering");
        this.$router.push({ path: "/contractEntersing" });
        sessionStorage.setItem("contractType", this.housingInfo.status); // !!
        sessionStorage.removeItem("contractMsg");
        sessionStorage.removeItem("employeeId"); // todo
        sessionStorage.setItem("concractFrom", "house");
      } else if (command === "修改状态") {
        this.amendStatus = true;
      }
      else if (command === "纠错") {
        this.errorStatus = true;
      }
    },
    //添加反馈
    openFaceback(id, withLookid, takeLookName, watchName) {
      this.takeLookName = takeLookName;
      this.watchName = watchName;
      sessionStorage.setItem("daikanId", id);
      sessionStorage.setItem("withLook", withLookid);
      this.feedbackDialog = true;
    },
    //删除
    delete() {
      let params = {
        buildingInfoId: sessionStorage.getItem("sellShopbuildId"),
        residentialAreaId: this.housingInfo.residentialAreaId,
      };
      this.$post(houseDelete, params).then((res) => {
        if (res.success) {
          this.$message.success({
            message: res.msg,
            type: "success",
            duration: 1000,
          });
          this.$store.commit("delete_tabs", this.$route.path);
          this.$router.push({
            path: "/sellShop",
            query: { iskeep: true },
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    //查询图片日志
    querypicLog() {
      let params = {
        houseId: this.housingInfo.buildingInfoId,
        "page.pageNumber":
          this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
      };
      this.$post(querypicLog, params).then((res) => {
        if (res.success) {
          this.tableData3 = res.data;
          this.total = res.total;
          this.tableData3.map((item) => {
            if (item.operationDate) {
              item.operationDate = item.operationDate.replace(
                "T",
                "    "
              );
            }
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //查询房源日志
    querWorkbook() {
      //  //cosole.log(this.housingInfo.buildingInfoId);
      let params = {
        houseId: this.housingInfo.buildingInfoId,
        "page.pageNumber":
          this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
      };
      this.$post(queryLog, params).then((res) => {
        if (res.success) {
          this.tableData3 = res.data;
          this.total = res.total;
          this.tableData3.map((item) => {
            if (item.operationDate) {
              item.operationDate = item.operationDate.replace(
                "T",
                "    "
              );
            }
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 查询房源图片信息
    queryHousePictur() {
      let params = {
        buildingInfoId: sessionStorage.getItem("sellShopbuildId"),
        "page.pageNumber":
          this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
      };

      this.$post(queryHousePictur, params).then((res) => {
        if (res.success) {
          if (res.data.indoorPicture) {
            res.data.indoorPicture.map((item, index) => {
              // draw(
              //   "indoorPicture" + index,
              //   this.watermarkData.watermarkType,
              //   "http://" + item.uri,
              //   "http://" + this.watermarkData.pictureAddress,
              //   "myCanvas" + index,
              //   this.watermarkData.transparency,
              //   this.watermarkData.watermarkLocation,
              //   this.watermarkData.horizontalDistance,
              //   this.watermarkData.verticalMargin
              // );
              item.istrue = false;
            });
          }
          if (res.data.surveyIndoorPicture) {
            res.data.surveyIndoorPicture.map((item, index) => {
              // draw(
              //   "surveyIndoorPicture" + index,
              //   this.watermarkData.watermarkType,
              //   "http://" + item.uri,
              //   "http://" + this.watermarkData.pictureAddress,
              //   "myCanvas1" + index,
              //   this.watermarkData.transparency,
              //   this.watermarkData.watermarkLocation,
              //   this.watermarkData.horizontalDistance,
              //   this.watermarkData.verticalMargin
              // );
              item.istrue = false;
            });
          }
          // if (res.data.apartmentPicture) {
          //   res.data.apartmentPicture.map((item, index) => {
          //     draw(
          //       "apartmentPicture" + index,
          //       this.watermarkData.watermarkType,
          //       "http://" + item.uri,
          //       "http://" + this.watermarkData.pictureAddress,
          //       "myCanvas2" + index,
          //       this.watermarkData.transparency,
          //       this.watermarkData.watermarkLocation,
          //       this.watermarkData.horizontalDistance,
          //       this.watermarkData.verticalMargin
          //     );
          //   });
          // }
          // if (res.data.surveyApartmentPicture) {
          //   res.data.surveyApartmentPicture.map((item, index) => {
          //     draw(
          //       "surveyApartmentPicture" + index,
          //       this.watermarkData.watermarkType,
          //       "http://" + item.uri,
          //       "http://" + this.watermarkData.pictureAddress,
          //       "myCanvas3" + index,
          //       this.watermarkData.transparency,
          //       this.watermarkData.watermarkLocation,
          //       this.watermarkData.horizontalDistance,
          //       this.watermarkData.verticalMargin
          //     );
          //   });
          // }
          // if (res.data.secretPicture) {
          //   res.data.secretPicture.map((item, index) => {
          //     draw(
          //       "secretPicture" + index,
          //       this.watermarkData.watermarkType,
          //       "http://" + item.uri,
          //       "http://" + this.watermarkData.pictureAddress,
          //       "myCanvas4" + index,
          //       this.watermarkData.transparency,
          //       this.watermarkData.watermarkLocation,
          //       this.watermarkData.horizontalDistance,
          //       this.watermarkData.verticalMargin
          //     );
          //   });
          // }
          // if (res.data.surveySecretPicture) {
          //   res.data.surveySecretPicture.map((item, index) => {
          //     draw(
          //       "surveySecretPicture" + index,
          //       this.watermarkData.watermarkType,
          //       "http://" + item.uri,
          //       "http://" + this.watermarkData.pictureAddress,
          //       "myCanvas5" + index,
          //       this.watermarkData.transparency,
          //       this.watermarkData.watermarkLocation,
          //       this.watermarkData.horizontalDistance,
          //       this.watermarkData.verticalMargin
          //     );
          //   });
          // }

          this.buildInfo = [];
          this.buildInfo = res.data;
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },

    queryTopStatus() {
      let permisList1 = JSON.parse(sessionStorage.getItem("permisList1"));
      let permissionLevel = 0;
      if (this.permisShow("置顶")) {
        permisList1.map((item) => {
          if (item.functionName == "置顶") {
            permissionLevel = item.level;
          }
        });
      } else {
        permissionLevel = 6;
      }
      let params = {
        buildingInfoId: sessionStorage.getItem("sellShopbuildId"),
        permissionLevel: permissionLevel,
      };
      this.$post(queryTopStatus, params).then((res) => {
        if (res.success) {
          this.housingInfo.isTop = res.data.isTop;
          this.housingInfo.showPermission = res.data.showPermission;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    topHouse() {
      if (this.housingInfo.isTop == 0) {
        if (!this.topDate) {
          this.$message.error("置顶天数不能为空");
          return;
        }
      }
      let params = {
        buildingInfoId: sessionStorage.getItem("sellShopbuildId"),
        topStatus: this.housingInfo.isTop ? 0 : 1,
        topDate: this.topDate || 1,
      };
      this.$post(topHouse, params).then((res) => {
        if (res.success) {
          let msg = this.housingInfo.isTop
            ? "取消置顶成功"
            : "置顶成功";
          this.$message.success(msg);
          this.atTopVisible = false;
          this.queryTopStatus();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 房源详情
    getDetailsBtn() {
      let params = {
        buildingInfoId: sessionStorage.getItem("sellShopbuildId"),
      };
      this.$post(houseTypeDetail, params).then((res) => {
        if (res.success) {
          sessionStorage.setItem(
            "houseType",
            res.data.housingProperty
          );
          localStorage.setItem("houseMsg", JSON.stringify(res.data));
          // sessionStorage.setItem("housingInfo", res.data);
          // sessionStorage.setItem("fangemployeeId",res.data.employeeId);
          // sessionStorage.setItem("fangstoreId", res.data.storeId);
          res.data.partOwnerInfo.map((item, index) => {
            item.phone = item.phone.join(",");
          });
          if (res.data.applicableToIndustryName.length !== 0) {
            res.data.applicableToIndustryName = res.data.applicableToIndustryName.join(",");
          }
          this.housingInfo = res.data;
          let permisList = res.data.rflist;
          if (permisList) {
            permisList.map((item) => {
              this.permisList.push(item.functionName);
            });
          }
          if (this.housingInfo.keyId === null) {
            this.keyShow = true;
          } else {
            this.keyShow = false;
            this.keyTitle = "操作钥匙";
          }
          this.curHouseStatus = this.housingInfo.status;
          if (this.housingInfo.approvalStatus == 'TO_BE_AUDITED' || this.housingInfo.approvalStatus == 'UNABLE') {
            this.overSave = true;
          } else {
            if (this.housingInfo.status == "SOLD" || this.housingInfo.status == "DEAL" || this.housingInfo.status == "INVALID") {
              this.overSave = true;
            }
          }
          this.getstatus(true);
          this.getCustomerLevel(); //查询客户级别
          this.getMaritalStatus(); //查询婚姻
          this.getSex(); //查询性别
          this.gettaxPaymentList(); //查询税费支付
          this.getPayWayList(); //查询付款方式
          this.getHouseLevel(); //查询房源类型
          this.getRelyStreetList(); //查询临街
          this.getMortgageList(); //查询抵押
          this.getSeeHouseMode(); //查询看房方式
          this.getNatureList(); //查询性质
          this.getSourceList(); //查询来源

          this.getOwnerProperty(); // 查询房屋权属
          this.getSituation(); // 查询房屋现状
          this.getDecorationDegree(); // 查询装修程度
          this.getBuildingType(); // 查询建筑类型
          this.getProperty(); // 查询产权
          this.gethousingStructure(); // 查询房屋结构
          this.getPriceCondition(); // 查询价格条件
          this.getSexList(); //共有人性别
          this.gethousingResourceType(); //查询物业类型
          this.getbuildingStructure(); //查询建筑结构
          this.getnatureRights(); //产权性质
          this.getvacateTime(); //腾房时间
          // this.getFeaturesList(); //特性
          this.getbuildlist(); //查询朝向
          this.getHouseRelatedPersonnel(); //查询相关人员
          this.queryTopStatus();
          this.queryWhetherFollowUp();

          this.queryHouseMatchCustomerList(); //客源匹配
          if (this.$route.query.tabIndex) {
            this.activeName2 = "匹配";
          }
        }
      });
    },
    //查询跟进
    getQueryFollowUpList() {
      let params = {
        houseId: sessionStorage.getItem("sellShopbuildId"),
        "page.pageNumber":
          this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
      };
      this.$post(queryFollowUp, params).then((res) => {
        if (res.success) {
          this.queryFollowUpList = res.data;
          this.total = res.total;
          this.queryFollowUpList.map((item) => {
            if (item.followUpTime) {
              item.followUpTime = item.followUpTime.replace(
                "T",
                "    "
              );
            }
            if (item.remindStartTime) {
              item.remindStartTime = item.remindStartTime.replace(
                "T",
                "    "
              );
            }
            if (item.remindEndTime) {
              item.remindEndTime = item.remindEndTime.replace(
                "T",
                "    "
              );
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    //客源匹配
    getQueryIntention() {
      let params = {
        houseId: sessionStorage.getItem("sellShopbuildId"),
        "page.pageNumber":
          this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
      };
      this.$post(queryIntention, params).then((res) => {
        if (res.success) {
          this.queryIntentionList = res.data;
          this.total = res.total;
          this.queryIntentionList.map((item, index) => {
            if (item.customerIntention === null) {
              this.queryIntentionList.splice(index, 1);
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    //带看信息
    getQueryWithLookList() {
      let params = {
        houseId: sessionStorage.getItem("sellShopbuildId"),
        "page.pageNumber":
          this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
      };
      this.$post(queryWithLook, params).then((res) => {
        if (res.success) {
          this.queryWithLookList = res.data;
          this.total = res.total;
          this.queryWithLookList.map((item) => {
            if (item.withLookTime) {
              item.withLookTime = item.withLookTime.replace(
                "T",
                "    "
              );
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageNumber = val;
      if (this.isShow) {
        this.querWorkbook();
      } else {
        this.querypicLog();
      }
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageNumber = 1;
      this.pageSize = val;
      if (this.isShow) {
        this.querWorkbook();
      } else {
        this.querypicLog();
      }
    },
    //分页
    handleSizeChange1(val) {
      this.currentPage = 1;
      this.pageNumber = 1;
      this.pageSize = val;
      this.getQueryFollowUpList(); //每页显示条数
    },
    handleCurrentChange1(val) {
      this.pageNumber = val;
      this.getQueryFollowUpList(); //当前页
    },
    handleSizeChange2(val) {
      this.currentPage = 1;
      this.pageNumber = 1;
      this.pageSize = val;
      this.getQueryIntention(); //每页显示条数
    },
    handleCurrentChange2(val) {
      this.pageNumber = val;
      this.getQueryIntention(); //当前页
    },
    handleSizeChangep(val) {
      this.currentPage = 1;
      this.pageNumber = 1;
      this.pageSize = val;
      this.queryHouseMatchCustomerList(); //每页显示条数
    },
    handleCurrentChangep(val) {
      this.pageNumber = val;
      this.queryHouseMatchCustomerList(); //当前页
    },
    //分页
    handleSizeChange3(val) {
      this.currentPage = 1;
      this.pageNumber = 1;
      this.pageSize = val;
      this.getQueryWithLookList(); //每页显示条数
    },
    handleCurrentChange3(val) {
      this.pageNumber = val;
      this.getQueryWithLookList(); //当前页
    },
    showcurlookPicturList(data, imglist, id) {

      if (getRouterLevel('带看图片编辑') == 0) {
        this.$message.error('暂无权限');
        return;
      }
      let params = {
        employeeId: id,
        permissionLevel: getRouterLevel('带看图片编辑'),
      };
      this.$post(checkWithLookPicturePermission, params).then(res => {
        if (res.success) {
          this.propimg = imglist;
          //cosole.log(2222222222, this.propimg);
          this.lookImgVisible = true;
          this.curImg = data;
        } else {
          this.$message.error('暂无权限')
        }
      })
    },
    showlookPicturList(data, imglist, id) {
      if (getRouterLevel('带看图片查看') == 0) {
        this.$message.error('暂无权限');
        this.isRowColor = '';
        return;
      }
      let params = {
        employeeId: id,
        permissionLevel: getRouterLevel('带看图片查看'),
      };
      this.$post(checkWithLookPicturePermission, params).then(res => {
        if (res.success) {
          this.propimg = imglist;
          //cosole.log(2222222222, this.propimg);
          this.uploadImgVisible = true;
          this.curImg = data;
        } else {
          this.$message.error('暂无权限')
        }
        this.isRowColor = '';
      })
    },
    showPicturList(data) {
      let result = this.permisShow("图片上传");
      //cosole.log(222222222222222222222, result);
      if (!result) {
        this.$message({
          message: "暂无上传图片权限",
          type: "error",
        });
        return false;
      }
      if (data == "roomPicture") {
        this.isIndoorImg = true;
      } else {
        this.isIndoorImg = false;
      }
      this.uploadHouseImgVisible = true;
      this.curImg = data;
    },

    // 房源归属
    getOwnership() {
      let params = {
        code: "",
      };
      getScreening(params).then((res) => {
        //  //cosole.log(res);
      });
    },
    // 查询价格条件
    getPriceCondition() {
      let params = { code: "priceTerms" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.priceTerms == item.value) {
              this.housingInfo.priceTerms = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询房屋权属
    getOwnerProperty() {
      let params = { code: "housingOwnership" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.housingOwnership == item.value) {
              this.housingInfo.housingOwnership = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询客户级别
    getCustomerLevel() {
      this.$post(customerLevel).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.level == item.value) {
              this.housingInfo.level = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询婚姻
    getMaritalStatus() {
      let params = { code: "marriage" };
      this.$post(dicGet, params).then((res) => {
        //  //cosole.log(res.data);
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.marriage == item.value) {
              this.housingInfo.marriage = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询性别
    getSex() {
      if (this.housingInfo.sex == "MALE") {
        this.housingInfo.sex = "男";
      } else if (this.housingInfo.sex == "FEMALE") {
        this.housingInfo.sex = "女";
      }
    },
    // 查询税费支付
    gettaxPaymentList() {
      let params = { code: "taxPayment" };
      this.$post(dicGet, params).then((res) => {
        //  //cosole.log(res.data);
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.taxPayment == item.value) {
              this.housingInfo.taxPayment = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询付款方式
    getPayWayList() {
      let params = { code: "secondPaymentMethod" };
      this.$post(dicGet, params).then((res) => {
        //  //cosole.log(res.data);
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.paymentMethod == item.value) {
              this.housingInfo.paymentMethod = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询房源类型
    getHouseLevel() {
      let params = { code: "houseLevel" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.houseLevel == item.value) {
              this.housingInfo.houseLevel = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    //查询临街
    getRelyStreetList() {
      if (this.housingInfo.frontage == "NO") {
        this.housingInfo.frontage = "否";
      } else if (this.housingInfo.frontage == "YES") {
        this.housingInfo.frontage = "是";
      }
    },
    //查询抵押
    getMortgageList() {
      if (this.housingInfo.mortgageSituation == "SECURED") {
        this.housingInfo.mortgageSituation = "有抵押";
      } else if (this.housingInfo.mortgageSituation == "UNSECURED") {
        this.housingInfo.mortgageSituation = "无抵押";
      }
    },
    // 查询看房方式
    getSeeHouseMode() {
      let params = { code: "houseInspectionMethod" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (
              this.housingInfo.houseInspectionMethod == item.value
            ) {
              this.housingInfo.houseInspectionMethod =
                item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询性质
    getNatureList() {
      let params = { code: "property" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.property == item.value) {
              this.housingInfo.property = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询来源
    getSourceList() {
      let params = { code: "source" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.source == item.value) {
              this.housingInfo.source = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询特性
    getFeaturesList() {
      // let houseType = this.$store.state.houseType;
      // if (houseType == "SECONDHAND") {
      //     this.houseTypeFeatures = "";
      // } else if (houseType == "RENTING") {
      //     this.houseTypeFeatures = "rentalHousingFeatures";
      // }
      let params = { code: "saleHousingFeatures" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          for (let i = 0; i < res.data.length; i++) {
            for (
              let k = 0;
              k < this.housingInfo.features.length;
              k++
            ) {
              if (
                res.data[i].value ==
                this.housingInfo.features[k] ||
                res.data[i].isActive
              ) {
                res.data[i].isActive = true;
              } else {
                res.data[i].isActive = false;
              }
            }
          }
          this.featuresList = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 共有人性别
    getSexList() {
      if (this.housingInfo.partOwnerSex == "MALE") {
        this.housingInfo.partOwnerSex = "男";
      } else if (this.housingInfo.partOwnerSex == "FEMALE") {
        this.housingInfo.partOwnerSex = "女";
      }
    },
    //物业类型
    gethousingResourceType() {
      let params = { code: "tungPurpose" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (
              this.housingInfo.housingResourceType == item.value
            ) {
              this.housingInfo.housingResourceType =
                item.valueDesc;
            }
          });
        }
      });
    },
    //查询建筑结构
    getbuildingStructure() {
      let params = { code: "buildingStructure" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.buildingStructure == item.value) {
              this.housingInfo.buildingStructure = item.valueDesc;
            }
          });
        }
      });
    },
    //查询房屋结构
    gethousingStructure() {
      let params = { code: "housingStructure" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.housingStructure == item.value) {
              this.housingInfo.housingStructure = item.valueDesc;
            }
          });
        }
      });
    },
    // 查询房屋现状
    getSituation() {
      let params = { code: "houseStatus" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.houseStatus == item.value) {
              this.housingInfo.houseStatus = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询装修程度
    getDecorationDegree() {
      let params = { code: "decorationDegree" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.decorationDegree == item.value) {
              this.housingInfo.decorationDegree = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询建筑类型
    getBuildingType() {
      let params = { code: "residentialBuildingsTypes" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.architecturalType == item.value) {
              this.housingInfo.architecturalType = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询产权
    getProperty() {
      let params = { code: "shopPropertyRight" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.propertyRight == item.value) {
              this.housingInfo.propertyRight = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询产权性质
    getnatureRights() {
      let params = { code: "natureRights" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (
              this.housingInfo.propertyRightNature == item.value
            ) {
              this.housingInfo.propertyRightNature =
                item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询腾房时间
    getvacateTime() {
      let params = { code: "vacateTime" };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          res.data.map((item, index) => {
            if (this.housingInfo.vacateTime == item.value) {
              this.housingInfo.vacateTime = item.valueDesc;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    //查询图片上传文件夹
    getImgFolder() {
      this.$post(qiniuOne).then((res) => {
        if (res.success) {
          this.imgToken = res;
        }
      });
    },
    closeBtn() {
      this.imgs = [];
      this.upLoadUrl = [];
      this.isSave = false;
    },

    // 图片保存
    upLoadingBtn(data) {
      if (data.length == 1) {
        this.uploadImgVisible = false;
      } else {
        let params = {
          withLookId: this.curImg,
          withLookPicture: JSON.stringify(data),
        };
        this.$post(addWithLookImg, params).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getQueryWithLookList();
            this.isRowColor = "";
            this.uploadImgVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      }
    },

    // 删除图片
    deletImg(data) {
      this.$confirm(
        "确认要删除选中的图片吗，删除后将不可恢复，请谨慎操作?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (data.length == 0) {
            this.$message({
              type: "error",
              message: "请至少选择一张图片",
            });

            return;
          }
          let params = {
            picturesId: data,
            buildingInfoId: sessionStorage.getItem("sellShopbuildId"),
          };
          this.$post(uploadDeletImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.queryHousePictur();
              this.imgListShow = false;
              this.imgCheckallShow = false;
            } else {
              this.imgCheckallShow = false;
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //     type: "info",
          //     message: "已取消删除",
          // });
        });
    },

    updateWebPicture(data) {
      // 设为默认图片
      let params = {
        houseId: sessionStorage.getItem("sellShopbuildId"),
        webPicture: data,
      };
      this.$post(updateWebPicture, params).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.queryHousePictur();
          this.imgListShow = false;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },

    downLoadImg(item) {
      // 下载图片
      sessionStorage.setItem("downImg", item);
      this.$electron.ipcRenderer.send("open-directory-dialog");
    },

    downLoadImgList() {
      // 下载图片

      let arr = [];
      if (this.permisShow("保密图片查看")) {
        // arr = [...this.buildInfo.indoorPicture];
        arr = [
          ...this.buildInfo.indoorPicture,
          ...this.buildInfo.surveyIndoorPicture,
          ...this.buildInfo.surveyApartmentPicture,
          ...this.buildInfo.apartmentPicture,
          ...this.buildInfo.secretPicture,
          ...this.buildInfo.surveySecretPicture,
        ];
      } else {
        // arr = [...this.buildInfo.indoorPicture, ...this.buildInfo.apartmentPicture]
        arr = [
          ...this.buildInfo.indoorPicture,
          ...this.buildInfo.surveyIndoorPicture,
          ...this.buildInfo.surveyApartmentPicture,
          ...this.buildInfo.apartmentPicture,
        ];
      }
      // console.log(123, arr);
      sessionStorage.setItem("downImgList", JSON.stringify(arr));
      sessionStorage.setItem("downImgListDirName", `/${this.housingInfo.buildingInfoId}-${this.housingInfo.residentialAreaName}-商铺买卖/`
      );
      this.$electron.ipcRenderer.send("open-directorylist-dialog");
    },

    // 保存房间图片
    uploadHouseBtn(data) {
      if (!Array.isArray(data)) {
        let params = {
          id: data.id,
          label: data.label,
        };

        this.$post(updateHouseImg, params).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: res.msg,
            });

            this.uploadHouseImgVisible = false;
            this.queryHousePictur();
            this.querWorkbook(); //查询房源日志
            this.querypicLog(); //查新图片日志
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        let curbuildId = sessionStorage.getItem("sellShopbuildId");
        if (this.curImg == "roomPicture") {
          let params = {
            roomPicture: JSON.stringify(data),
            buildingInfoId: curbuildId,
          };
          this.$post(updateHousePictur, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadHouseImgVisible = false;
              this.queryHousePictur();
              this.querWorkbook(); //查询房源日志
              this.querypicLog(); //查新图片日志
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else if (this.curImg == "houseTypePicture") {
          let params = {
            houseTypePicture: JSON.stringify(data),
            buildingInfoId: curbuildId,
          };
          this.$post(updateHousePictur, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadHouseImgVisible = false;
              this.queryHousePictur();
              this.querWorkbook(); //查询房源日志
              this.querypicLog(); //查新图片日志
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else if (this.curImg == "secretPicture") {
          let params = {
            secretPicture: JSON.stringify(data),
            buildingInfoId: curbuildId,
          };
          this.$post(updateHousePictur, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadHouseImgVisible = false;
              this.queryHousePictur();
              this.querWorkbook(); //查询房源日志
              this.querypicLog(); //查新图片日志
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      }
    },
  },

  components: {
    IntegrityTable,
    addErrorHouse,
    NewFollowAlert,
    AddKeyAlert,
    TurnAttributionAlert,
    TurnTable,
    HousingOnline,
    HousingSolid,
    TakeLookHouse,
    FeedBack,
    UploadImg,
    operationKeyAlert,
    AboutUserTable,

  },
};
</script>

<style lang="less" >
.el-message-box__wrapper {
  z-index: 3001 !important;
}
.house_details {
  margin: 14px;
  background: #fff;
  padding: 27px;
  .el-dialog__body {
    padding: 30px 0 0 0;
    .leaveRequest_content {
      padding: 20px 30px 0 30px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &_div {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 10px 0;
          .el-checkbox-group {
            margin: 0;
            .el-checkbox__label {
              > span {
                padding: 0 2px;
                color: red;
              }
            }
          }
          .label {
            min-width: 100px;
            display: inline-block;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            text-align: right;
            .notice {
              color: #ff0000;
            }
          }
          .el-input__icon {
            line-height: 26px;
          }
          .el-radio {
            padding: 5px 0;
          }
          .el-input {
            width: 80px;
            height: 26px;
            margin-right: 20px;
            .el-input__inner {
              width: 80px;
              height: 26px;
              padding: 0 10px;
              height: 26px;
            }
          }
        }
      }
    }
  }
  .dialog-foot {
    text-align: right;
    margin-top: 50px;
    background: #f5f5f5;
    padding: 20px;
    .foot-cancel,
    .foot-save {
      width: 80px;
      height: 40px;
      border: none;
      outline: none;
      border-radius: 4px;
      font-size: 16px;
      color: #ffffff;
      margin-right: 20px;
    }
    .foot-cancel {
      background: #cccccc;
    }
    .foot-save {
      background: #5e75e6;
    }
  }
  .amend_status_inner {
    margin: 10px 35px;
  }
  .amend_status_inner {
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-input__icon {
      line-height: 30px;
    }
  }
  .add_fac_item_wrap {
    display: flex;
    flex-wrap: wrap;
    .add_fac_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 15px;
      position: relative;
      width: 85px;
      padding: 0;
      text-align: center;

      > i {
        font-size: 30px;
        color: #5e75e6;
      }

      &.active {
        > i {
          color: #5e75e6;
        }

        > span {
          font-size: 12px;
          color: #5e75e6;
        }
      }
    }
  }
  .house_title {
    padding: 12px 0;
    border-bottom: 1px solid #ccc;
  }
  .key_title {
    font-size: 14px;
    color: #999999;
    margin: 30px;
    display: flex;
  }
  .key_title {
    span {
      width: 80px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }
    .activeBtn {
      width: 80px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background: #5e75e6;
      color: #fff;
    }
  }
  .details_tabs {
    position: relative;
    // margin-right: 60px;
    .footer_page {
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .el-tabs__header {
      margin: 0;

      .el-tabs__nav-wrap {
        align-items: center;
        border-bottom: 2px solid #5e75e6;
        .el-tabs__nav {
          border: none;
        }
        .el-tabs__item {
          width: 100px;
          text-align: center;
          color: #666666;
          border-top: 1px solid #eee;
          border-bottom: none;

          &.is-active {
            color: #fff;
            background: #5e75e6;
            text-align: center;
          }

          > span {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .iconfont {
              font-size: 30px;
              margin-top: 20px;
            }
          }
        }
        .el-tabs__item:first-child {
          border-left: 1px solid #eee;
          &.is-active {
            border-left: none;
          }
        }
        .el-tabs__item:last-child {
          border-right: 1px solid #eee;
          &.is-active {
            border-right: none;
          }
        }
      }
    }

    .basis_info {
      .owner_information_one {
        border: 1px solid #e1e1e1;
        > h3 {
          height: 40px;
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          background: #f2f4ff;
          padding-left: 17px;
          i {
            width: 6px;
            height: 16px;
            background: rgba(94, 117, 230, 1);
            border-radius: 3px;
            margin-right: 10px;
          }
        }
        .owner_info_list {
          display: flex;
          color: #333333;
          font-size: 16px;
          width: 100%;
          .owner_info_list_one {
            width: 20%;
            padding: 20px;
            border-left: 1px solid #cccccc;
            li {
              margin: 15px 0;
              span:first-child {
                color: #999;
              }
            }
          }
          .owner_info_list_one:first-child {
            border: none;
          }
        }
      }
      .owner_information_two {
        border: 1px solid #e1e1e1;
        > h3 {
          height: 40px;
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          background: #f2f4ff;
          padding-left: 17px;
          i {
            width: 6px;
            height: 16px;
            background: rgba(94, 117, 230, 1);
            border-radius: 3px;
            margin-right: 10px;
          }
        }
        .owner_info_list {
          display: flex;
          margin-top: 0;
          color: #333333;
          font-size: 16px;
          width: 100%;
          .owner_info_list_one {
            width: 20%;
            padding: 20px;
            border-left: 1px solid #cccccc;
            li {
              margin: 15px 0;
              span:first-child {
                color: #999;
              }
            }
          }
          .owner_info_list_one:first-child {
            border: none;
          }
        }
        .owner_info_list:last-child {
          display: flex;
          margin-top: 0;
          color: #333333;
          font-size: 16px;
          width: 100%;
          .owner_info_list_one {
            width: 50%;
            padding: 20px;
            border-left: 1px solid #cccccc;
            li {
              margin: 15px 0;
              span:first-child {
                color: #999;
              }
            }
          }
          .owner_info_list_one:first-child {
            border: none;
          }
        }
        .owner_info_twoMore {
          padding: 20px;
          border-top: 1px solid #e1e1e1;
          ul {
            li {
              margin: 15px 0;
              span:first-child {
                color: #999;
              }
            }
          }
        }
        .owner_info_status {
          padding: 20px;
          border-top: 1px solid #e1e1e1;
          border-bottom: 1px solid #e1e1e1;
        }
      }
      .owner_information_three {
        border: 1px solid #e1e1e1;
        > h3 {
          height: 40px;
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          background: #f2f4ff;
          padding-left: 17px;
          i {
            width: 6px;
            height: 16px;
            background: rgba(94, 117, 230, 1);
            border-radius: 3px;
            margin-right: 10px;
          }
        }
        .owner_info_list {
          width: 100%;
          display: flex;
          margin-top: 0;
          color: #333333;
          font-size: 16px;
          border-bottom: 1px solid #cccccc;
          .owner_info_list_one {
            padding: 12px;
            display: flex;
            justify-content: space-between;
            li {
              flex: 1;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              span:first-child {
                color: #999;
              }
              span:nth-child(2) {
                span {
                  color: #000;
                }
              }
            }
          }
          .owner_info_list_one:first-child {
            width: 5%;
            text-align: center;
            border-right: 1px solid #cccccc;
            color: #333333;
          }
          .owner_info_list_one:last-child {
            width: 95%;
          }
        }
        .owner_info_list:last-child {
          border-bottom: none;
        }
      }
      @media screen and (max-width: 1500px) {
        .owner_information_three {
          border: 1px solid #e1e1e1;
          > h3 {
            height: 40px;
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            background: #f2f4ff;
            padding-left: 17px;
            i {
              width: 6px;
              height: 16px;
              background: rgba(94, 117, 230, 1);
              border-radius: 3px;
              margin-right: 10px;
            }
          }
          .owner_info_list {
            width: 100%;
            display: flex;
            margin-top: 0;
            color: #333333;
            font-size: 16px;
            border-bottom: 1px solid #cccccc;
            .owner_info_list_one {
              padding: 12px;
              display: flex;
              justify-content: space-between;
              li {
                flex: none;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                span:first-child {
                  color: #999;
                }
                span:nth-child(2) {
                  span {
                    color: #000;
                  }
                }
              }
            }
            .owner_info_list_one:first-child {
              width: 50px;
              display: flex;
              justify-content: center;
              border-right: 1px solid #cccccc;
              color: #333333;
            }
            .owner_info_list_one:last-child {
              width: 1000px;
              li:nth-child(1) {
                width: 180px;
              }
              li:nth-child(2) {
                width: 120px;
              }
              li:nth-child(3) {
                width: 130px;
              }
              li:nth-child(4) {
                width: 200px;
              }
              li:nth-child(5) {
                width: 250px;
              }
              li:nth-child(6) {
                width: 200px;
              }
            }
          }
          .owner_info_list:last-child {
            border-bottom: none;
          }
        }
      }
      .owner_information_four {
        border: 1px solid #e1e1e1;
        > h3 {
          height: 40px;
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          background: #f2f4ff;
          padding-left: 17px;
          i {
            width: 6px;
            height: 16px;
            background: rgba(94, 117, 230, 1);
            border-radius: 3px;
            margin-right: 10px;
          }
        }
        .owner_info_list {
          display: flex;
          color: #333333;
          font-size: 16px;
          .owner_info_list_one {
            width: 100%;
            padding: 20px;
            border-right: 1px solid #cccccc;
            li {
              display: flex;
              margin: 15px 0;
              span:first-child {
                min-width: 85px;
                color: #999;
              }
            }
          }
          .owner_info_list_one:last-child {
            border: none;
          }
        }
      }
      .related-personnel {
        border: 1px solid #e1e1e1;
        > h3 {
          height: 40px;
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          background: #f2f4ff;
          padding-left: 17px;
          i {
            width: 6px;
            height: 16px;
            background: rgba(94, 117, 230, 1);
            border-radius: 3px;
            margin-right: 10px;
          }
        }
        .basic_info_title {
          border: none;
        }
      }
    }

    .ownership_wrap {
      margin-top: 28px;

      .ownership_title {
        display: flex;
        justify-content: space-between;

        > p {
          font-size: 16px;
          color: #5e75e6;
          display: flex;
          align-items: center;

          .iconfont {
            font-size: 30px;
            margin-right: 10px;
          }
        }

        .add_btn {
          font-size: 14px;
          color: #5e75e6;
          display: flex;
          align-items: center;
          width: 110px;
          height: 40px;
          border: 1px solid #5e75e6;
          outline: none;
          background: white;

          .icon-icon_zhanghu {
            font-size: 26px;
          }
        }
      }

      .key_list_wrap {
        margin-top: 20px;
        height: 600px;
        overflow: hidden;
        overflow-y: scroll;
        margin-bottom: 100px;
        position: relative;
        .el-table td,
        .el-table th {
          text-align: center;
        }
      }
    }
  }
  .upload_img {
    margin: 30px;
    .upload_img_title {
      font-size: 14px;
      color: black;
    }
    .batchImg {
      background: rgb(34, 202, 133);
      border: 1px solid rgb(34, 202, 133);
      float: right;
    }

    .upload_img_type {
      margin-top: 10px;
      display: flex;
      align-items: top;
      flex-wrap: wrap;
      width: 100%;
      position: relative;
      > li {
        position: relative;
      }

      .upload_img_icon {
        background: #f5f5f5;
        border: 1px solid #ccc;
        min-width: 150px;
        height: 100px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #bbb;
        margin-top: 12px;
        margin-right: 20px;
        margin-bottom: 12px;
        position: relative;
        overflow: hidden;
        .img_shikan {
          width: 30px;
          height: auto;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 8;
        }
        .img_fengmian {
          width: 30px;
          height: auto;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 8;
        }
        img {
          width: 152px;
          height: 102px;
        }

        .icon-icon_shinei,
        .icon-icon_huxing,
        .icon-icon_VR,
        .icon_baomi {
          font-size: 30px;
        }

        > span {
          margin-top: 5px;
          font-size: 14px;
        }
      }
      .txt {
        font-size: 14px;
        line-height: 22px;
        color: #999999;
        display: block;
        .icon-icon_xuanze {
          font-size: 22px;
        }
        .el-icon-check {
          font-size: 22px;
          color: #62b91a;
        }
        .el-input {
          width: 140px;
          margin-top: 10px;
        }
        .el-autocomplete {
          width: 140px;
        }
      }

      .upload_img_text {
        width: 150px;
        font-size: 14px;
        line-height: 20px;
        color: #bbb;
      }
    }
  }
  .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 3000;
    .close {
      width: 20px;
      position: absolute;
      top: 0;
      right: 200px;
      padding: 50px;
      z-index: 100 !important;
    }
    .delet {
      position: relative;
      width: 120px;
      padding-left: 36px;
      padding-right: 36px;
      margin-right: 20px;
      height: auto !important;
    }
    .set {
      position: relative;
      width: 120px;
      right: 0;
      padding-left: 36px;
      padding-right: 36px;
      margin-right: 20px;
      height: auto !important;
    }

    .download {
      border: none;
      background: #22ca85;
      color: #ffffff;
      position: relative;
      width: 120px;
      padding-left: 36px;
      padding-right: 36px;
      margin-right: 20px;
      height: auto !important;
    }

    .el-carousel__container {
      margin: 0 auto;
      width: 80%;
      height: 90vh;
      z-index: 99;
      .el-carousel__arrow {
        font-size: 50px !important;
        padding: 20px;
        width: 100px;
        height: 100px;
      }
    }

    .el-carousel__item {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      overflow: visible;
      // min-height: 400px;
      .uploadtime {
        width: 100%;
        line-height: 24px;
        color: #fff;
        position: absolute;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      > img {
        height: 90%;
      }
    }
  }
}
</style>

<style type="text/css" lang="less" scoped>
.upload_img_type {
  .el-input {
    .el-input__inner {
      width: 80% !important;
    }
  }
}

.keyStyle {
  .el-dialog {
    .el-dialog__body {
      padding: none !important;
    }
  }
}
.key_list_wrap {
  .active {
    color: #5e75e6;
    border-bottom: 1px solid #5e75e6;
    cursor: pointer;
  }
}

.txthidden {
  visibility: hidden;
}
.housing_dropdown {
  width: 240px;
  height: 280px;

  .el-popper .popper__arrow,
  .el-popper .popper__arrow::after {
    border: none;
  }

  .el-dropdown-menu {
    border: 1px solid red;
    padding-bottom: 30px;
  }

  .el-dropdown-menu__item {
    float: left;
    width: 33.33%;
    display: flex;
    flex-direction: column;
    line-height: 15px;
    padding: 0;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #5e75e6;
    font-size: 14px;
    padding-top: 10px;
  }

  .add_font {
    font-size: 30px;
  }

  .add_sales {
    margin-top: 8px;
  }
}

.house_details {
  .details_top {
    .housing_title {
      overflow: hidden;
      // 新增部门弹出框样式
      .el-dialog {
        .el-dialog__body {
          padding: 30px 0 0 0;
        }
        .el-dialog__title {
          font-size: 20px;
          color: #5e75e6;
        }
        .el-dialog__headerbtn .el-dialog__close {
          font-size: 25px;
        }
      }
      // 新增部门弹出框样式  end
      .housing_name_box {
        float: left;
        .housing_approvalStatus {
          .btn {
            background: #22ca85;
            color: #fff;
            margin-left: 30px;
            cursor: pointer;
          }
        }
        .housing_name {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          display: flex;
          align-items: flex-end;
          margin-top: 10px;
          > span {
            width: 46px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background: #ff904d;
            font-size: 14px;
            color: white;
            margin-left: 10px;
          }
          .status {
            background: #ff554d;
          }
          .icon_box {
            margin-left: 10px;
            .iconfont {
              font-size: 20px;
              &.icon-icon_yuechi {
                color: #00e567;
              }
              &.icon-icon_tupian {
                color: #ff2943;
              }
              &.icon-icon_VR {
                background: linear-gradient(to right, #47c8ff, #1350f3);
                background-clip: text;
                -webkit-background-clip: text;
                color: transparent;
              }
              &.icon-icon_dujia {
                background: linear-gradient(to right, #ff8936, #db5c35);
                background-clip: text;
                -webkit-background-clip: text;
                color: transparent;
              }
            }
          }
        }
        .housing_items {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #666666;
          margin-top: 10px;
        }
      }

      .el_dropdown_box {
        float: right;
        margin-top: 30px;
        display: flex;
        align-items: center;
        .el-dropdown {
          .el-button {
            width: 140px;
            height: 30px;

            background: #5e75e6;
            padding: 0;
          }
        }
        .housing_icon {
          display: flex;
          .iconfont {
            font-size: 30px;
          }
          .nav-icon {
            color: #999;

            text-align: center;
            margin-right: 50px;
            font-size: 14px;
            &.active {
              color: #5e75e6;
            }
          }
        }
      }
    }

    .housing_info {
      margin-top: 30px;

      .info_list {
        display: flex;

        .info_list_item {
          border-right: 1px solid #e6e6e6;
          text-align: center;

          .list_item_title {
            font-size: 14px;
            color: #666666;
            padding: 0 15px 10px 15px;
          }

          .list_item_text {
            font-size: 20px;
            color: #5e75e6;
            padding: 10px 15px 0 15px;
            border-top: 1px solid #e6e6e6;

            &.zongJ {
              color: #f64e4e;
            }
          }
        }

        .info_list_item:last-child {
          border: none;
        }
      }
    }

    .details_top_footer {
      display: flex;
      margin-top: 34px;
      padding-bottom: 40px;

      .weituo_data,
      .daoqi_data {
        font-size: 16px;
        color: #999999;

        > span {
          color: #333333;
        }
      }

      .daoqi_data {
        margin-left: 78px;
      }

      .peitao {
        margin-left: 145px;
        font-size: 14px;
        color: #333333;

        > span {
          margin-left: 26px;

          &.first {
            color: #5e75e6;
          }
        }
      }
    }
  }
}
.video_ul {
  padding-left: 30px;
  li {
    margin-top: 20px;
    margin-right: 20px;
    //text-align: center;
    display: inline-block;
    video {
      max-width: 300px;
      max-height: 300px;
    }
  }
}
</style>
